export default {
  router: {
    index: {
      home: "首页",
      login: "登录",
      error401: "error 401",
      error404: "error 404",
      error500: "error 500",
      userInfomation: "用户信息管理",
      delUserInfomation: "删除用户信息",
      connectionLog: "连接日志",
      topUpLog: "充值记录",
      expensesRecord: "消费记录",
      management: "管理设置模块",
      managementList: "管理设置",
      agentList: "公会管理",
      addAdmin: "添加管理员账户",
      operationalData: "运营数据管理",
      operateList: "全区运营数据",
      arList: "阿语区运营数据",
      noArList: "英语区运营数据",
      trList: "土语区运营数据",
      erList: "俄语区运营数据",
      bdList: "孟加拉区运营数据",
      giftManage: "礼物管理",
      giftManageEdit: "编辑管理列表",
      expressionManagement: "表情管理",
      onlineStatistics: "在线统计",
      topUpAgent: "充值代理管理",
      report: "举报处理",
      reportList: "举报处理",
      guildUsers: "主播管理", // 原公会用户管理
      guildIndex: "主播管理",
      guildConnect: "连接日志",
      matchPool: "匹配池记录",
      statistics: "平台运营数据",
      statisticsList: "运营数据管理",
      matchLog: "匹配日志",
      matchLog2: "批次对详情页",
      matchLog3: "优先级总分详情页",
      matchLog4: "关系总分详情页",
      matchLog5: "质量总分详情页",
      matchLog6: "匹配总分详情页",
      matchLog7: "落单用户页面",
      referrerUser: "推荐用户管理",
      photoAlbum: "相册",
      userDetail: "用户详情",
      eventManagement: "活动管理",
      itemsManagement: "座驾管理",
      groupManagement: "群组管理",
      groupManagementDetail: "群组管理详情",
      InfoInform: "消息通知",
      systemInformation: "系统消息",
      groupInformation: "群发消息",
      adManagement: "匹配Banner",
      itemsUserList: "用户列表",
      bannerInformation: "热门Banner",
      bannerMsg: "广告管理",
      groupBanner: "群组Banner",
      foundBanner: "发现Banner",
      agentBanner: "代理Banner",
      gameBanner: "游戏中心banner",
      roomTaskBanner: "房间任务banner",
      themeManager: "主题管理",
      tireManagement: "头饰管理",
      orderManagement: "勋章管理",
      goldLog: "金币扣除记录",
      deductLog: "豆子扣除记录",
      ipLog: "ip记录",
      facilityLog: "同设备账号记录",
      statement: "消费明细",
      batchIssue: "批量发放管理",
      diamondIssue: "钻石发放管理",
      nobilityIssue: "贵族发放管理",
      stageProperty: "道具发放管理",
      sendGameMoney: "游戏币发放管理",
      sendAwardOffer: "综合奖励发放",
      sendSvipOffer: "SVIP发放管理",
      sendAward: "发放奖励",
      groupSupport: "群组扶持",
      girlSupport: "女孩扶持",
      nationalPower: "家族管理",
      rechargeAgent: "充值代理管理",
      itemsParticularsList: "销售明细列表",
      vepAgentRouter: "二级代理信息管理",
      distribution: "分销明细",
      detailList: "查看详情",
      playingManagement: "玩法管理",
      luckyBox: "幸运盒子",
      h5luckyBox: "H5幸运盒子",
      fruits: "水果机",
      groupFight: "群组对战",
      fightDetail: "对战详情",
      fruitsBigwig: "水果大亨",
      activityDeploy: "活动配置",
      turntableDeploy: "转盘配置",
      taskDeploy: "任务配置",
      playerRoll: "选手名单",
      stateRoll: "国管名单",
      detailDeploy: "详情配置",
      batchIP: "批量IP查询",
      weekStar: "周星活动",
      flashScreen: "闪屏",
      operationPopup: "运营弹窗",
      uploadApk: "上传APK",
      riskManagement: "风险管理",
      rechargeRefund: "充值退款管理",
      deviceBlacklist: "设备黑名单管理",
      ipBlacklist: "IP黑名单管理",
      newUserAudit: "新用户奖励审核",
      groupAudit: "群组活动奖励审核",
      coinStatistics: "金币数据统计",
      videoChatStatistics: "视频聊天",
      dataStatistics: "数据统计",
      diamondRecharge: "充值用户管理",
      yellowRecharge: "黄钻充值",
      pinkRecharge: "粉钻充值",
      currencyType: "货币类型",
      autoRecharge: "双币充值",
      userRecharge: "用户充值",
      expandManagement: "推广员管理",
      certificationAudit: "真人认证审核",
      administratorOperationRecord: "管理员操作记录",
      setting: "设置",
      versionNumberSetting: "版本号设置",
      nameplateManagement: "铭牌管理",
      ornamentManagement: "ID装饰管理",
      roomLabelManagement: "房间标签管理",
      roomHeaderManagement: "房间头像框管理",
      materialDollManagement: "资料页挂饰管理",
      personalPage: "个人资料弹窗皮肤管理",
      taillightPage: "进房间尾灯皮肤管理",
      microphonePage: "麦位光波皮肤管理",
      bubbleBoxPage: "房间聊天气泡皮肤管理",
      mouldManagement: "道具管理",
      slotName: "slot榜单",
      candyName: "candy",
      diamondRecord: "钻石收入记录",
      greedyName: "greedy",
      gameSlotName: "多财多福",
      gameRacingName: "赛车游戏",
      getToken: "USER-TOKEN(内部)",
      getChart: "可视化图表",
      getCac: "日充统计",
      getActive: "日活统计",
      egyptSlotName: "埃及slot",
      fishingGameName: "捕鱼游戏",
      allActivityRoom: "房间充值活动",
      roomManagement: "常规房间充值活动",
      newRoomManagement: "新房管理",
      roomManageSys: "房间管理系统",
      specialRoom: "特殊房间充值活动",
      roomActivity: "房间活动",
      roomExamine: "房间审批",
      footballName: "足球slot",
      roomPrivilege: "代理特权操作记录",
      actBlacklist: "活动黑名单",
      sorceressSlotName: "女巫slot",
      teenpartyName: "Teenparty",
      whiteRoll: "checkout白名单",
      whiteRollFu: "是否把用户",
      whiteRollFuJoin: "移出checkout白名单?",
      addWhiteRoll: "新增白名单",
      actExcess: "活动补票",
      dotDataText: "充值数据",
      foodie: "foodie游戏",
      catFoodie: "猫猫Foodie游戏",
      luckyGift: "幸运礼物",
      delicious: "delicious游戏",
      football: "足球游戏",
      managerPanel: "国家经理数据面板",
      whitelist: "登录白名单管理",
      activityReboot: "活动重启",
      activityPopup: "弹窗活动",
      community: "广场管理",
      invitationChangeDetail: "邀请充值明细",
      invitationUserDetail: "邀请新用户明细"
    },
    router: {
      beforeClose: {
        sureClose: "确定要关闭了这一页吗"
      }
    }
  },
  views: {
    public: {
      operatSuccess: "操作成功",
      operatError: "操作失败",
      auditSuccess: "审核成功",
      auditError: "审核失败",
      pleaseInput: "请输入...",
      limitUpdate: "限制修改",
      limitUpdateTime: "限制时间",
      limitUpdateTimetext: "请选择时间",
      limitUpdateDel: "解除限制",
      limitUpdateDelTime: "用户被限制修改信息【%s】后限制解除",
      limitUpdateDelTimeText: "用户被【永久限制】修改信息",
      pass: "通过",
      refuse: "拒绝",
      passed: "已通过",
      refused: "已拒绝",
      close: "关闭",
      submit: "提交",
      yes: "是",
      no: "否",
      common: "普通",
      exclusive: "专属",
      sure: "确定",
      cancel: "取消",
      prompt: "提示",
      operation: "操作",
      delete: "删除",
      deduct: "扣除",
      newly: "新增",
      deductDay: "扣除天数",
      deductDay1: "扣除个数",
      edit: "编辑",
      query: "查询",
      update: "修改",
      turkish: "土耳其语",
      arabic: "阿语",
      indonesian: "印尼语",
      en: "英语",
      all: "全部",
      noPermission: "暂无权限",
      pleaseChoose: "请选择",
      pleaseArea: "请选择区域",
      dislodge: "清除",
      none: "无",
      have: "有",
      sex: "色情/性",
      curse: "侮辱谩骂",
      religion: "不尊重宗教",
      terroristActivities: "恐怖活动",
      violationOfLaw: "违法违规",
      propaganda: "宣传其他App",
      resetHeadImg: "重置头像",
      search: "搜索",
      ban7: "封禁7天",
      ban24: "封禁24小时",
      ban72: "封禁72小时",
      ban3: "封禁3小时",
      ban30D: "封禁30天",
      banTime: "封禁时间",
      banReason: "封禁原因",
      banDesc: "封禁描述",
      permanentBan: "永久封禁",
      confirmOpear: "确认执行该操作",
      noneData: "暂无数据",
      operatSuccessUpdate: "操作成功，更新状态中",
      pleaseChooseTarget: "请选择操作对象",
      chooseAll: "全选",
      saveBtn: "保存",
      male: "男",
      female: "女",
      startTime: "开始时间",
      endTime: "结束时间",
      chooseTime: "选择时间",
      topTime: "上架时间",
      bottomTime: "下架时间",
      onlineTime: "上线时间",
      transferTime: "转账时间",
      startTimeNotNull: "开始时间不能为空",
      pleaseEnter: "请输入用户ID",
      pleaseEnterAnchor: "请输入主播ID",
      showBigImg: "查看大图",
      pleaseEnterId: "请输入用户ID",
      matchCycle: "批次号",
      startAndEndTime: "开始时间或结束时间不能为空",
      countryText: "国家",
      exportText: "导出",
      exportText01: "累充用户数据",
      exportText02: "SVIP用户数据",
      exportText03: "收礼排行数据导出",
      orderCode: "订单号",
      orderPlaceholder: "请输入订单号",
      batchPass: "批量通过",
      batchReject: "批量拒绝",
      batchDispose: "批量处理",
      groupFu: "该用户没有群组",
      anchorNameFu: "请选择公会名",
      association: "公会",
      banned_harass: "在多个房间骚扰",
      banned_privacy: "侵犯他人隐私",
      banned_eroticism: "色情暴力内容",
      banned_damage: "损害官方利益",
      imgArVideo: "查看图片/视频",
      showBigVideo: "视频预览",
      operationSuccess: "操作成功",
      user_sum_recharge: "用户总充值：",
      allArea: "区域",
      onlineArea: "上线区域",
      entirelyArea: "全区",
      arArea: "阿语区",
      noArArea: "非阿语区",
      EnglishArea: "英语区",
      TurkishArea: "土语区",
      erArea: "俄语区",
      BengalArea: "孟加拉语区",
      appointCountry: "指定国家",
      onlineCountry: "上线国家",
      downloadTemplate: "下载模板",
      writeFull: "请填写完整",
      addAccount: "创建账号",
      othersArea: "其他区域",
      addedArea: "上架区域",
      infinTeSex: "不限",
      receptionLevel: "接收者等级",
      levelTop: "财富等级10级以上",
      levelTopVip: "SVIP且财富等级≥5级",
      sett: "设置代理销售明细可查询国家",
      sett2: "设置用户充值可查询国家",
      settAgency: "设置国家经理数据面板",
      setAwardArea: "设置可发放奖励区域",
      other: "其它",
      online: "在线代理",
      provideAward: "运营手动发放",
      seeTime: "可见时间",
      forEver: "永久",
      ThreeDay: "3天",
      sevenDay: "7天",
      thirtyDay: "30天",
      onlyFriend: "仅好友可见",
      onlyOneself: "仅自己可见",
      astrictWay: "可见方式"
    },
    videoChatStatistics: {
      // 0. 日期
      // 1. 日活：产品总日活，已有数据
      // 2. 视频人数：参与视频总人数（匹配+1v1人数去重）
      // 3. 视频留存：前一日视频的人中今日也使用视频功能的人数占比
      // 4. 总通话时长：视频通话总时长（包含匹配和1v1场景，包含免费通话及付费通话）
      // 5. 视频总消耗：在视频模块消耗的总钻石数，包括发起视频的消耗、延时消耗、视频内送礼消耗。
      // 6. 匹配人数：发起随机匹配的人数总和，无论是否成功。
      // 7. 匹配总次数：发起匹配的次数总和，无论是否成功。
      // 8. 匹配成功次数：匹配后成功进入视频界面的次数。
      // 9. 1v1人数：发起1v1视频的人数总和，无论是否成功。
      // 10. 1v1总次数：发起1v1通话的次数总和，无论是否接通。
      // 11. 1v1成功次数：发起1v1通话后，成功进入视频界面的次数。
      vcsText1: "日期",
      vcsText2: "日活",
      vcsText3: "视频人数",
      vcsText4: "视频留存",
      vcsText5: "视频总通话时长",
      vcsText6: "视频总消耗",
      vcsText7: "参与匹配人数",
      vcsText8: "发起匹配总次数",
      vcsText9: "匹配成功次数",
      vcsText10: "参与1v1人数",
      vcsText11: "1v1总次数",
      vcsText12: "1v1成功次数"
    },
    diamondRecharge: {
      tab_li1: "日期",
      tab_li2: "国家",
      tab_li3: "用户ID",
      tab_li4: "用户昵称",
      tab_li5: "充值金额",
      tab_li6: "是否举办首场活动",
      tab_li7: "注册时间",
      tab_li8: "SVIP等级",
      tab_li9: "时段最高单笔",
      tab_li10: "历史最高单笔",
      tab_li11: "游戏等级",
      tab_li12: "最新代理",
      tab_li13: "用户累计充值"
    },
    managementSetting: {
      addAdmin: "添加管理员账户",
      editAdmin: "编辑管理员账户",
      adminId: "登录名",
      adminUsername: "用户姓名",
      disable: "禁用",
      idText: "登录名",
      username: "用户姓名",
      newPassword: "新密码",
      againPassword: "确认密码",
      lastLoginIp: "上次登录IP",
      pleaseId: "请输入登录名",
      pleaseUserName: "请输入用户姓名",
      pleasePassword: "请输入密码",
      pleaseAgainPassword: "请确认密码",
      createSuccess: "创建账户成功",
      disable: "禁用",
      lastIp: "上次登录IP",
      editRole: "编辑角色",
      editManage: "编辑权限"
    },
    giftManage: {
      pleaseEnterGift: "请输入礼物名称搜索",
      addGiftBtn: "新增礼物",
      isUp: "已上架",
      unUp: "未上架",
      isUnUp: "已下架",
      waitUp: "待上架",
      giftId: "礼物ID",
      giftName: "礼物名称",
      giftIcon: "礼物图标",
      giftPrize: "礼物价值(宝石)",
      // overtimeCredit: "加时额度(秒)",
      status: "状态",
      sortOnShelf: "架上排序",
      putOnShelf: "上架",
      offShelf: "下架",
      uploadImgText: "上传图片",
      enableText: "是否确定上架该礼物",
      unEnableText: "是否确定下架该礼物",
      uploadIcon: "请上传礼物图标图片",
      uoloadEffect: "请上传礼物特效图片",
      editGift: "编辑礼物",
      giftTt: "礼物类型",
      textFu: "是否输入文字",
      giftIdFu: "是否ID礼物",
      giftIdUser: "绑定用户ID",
      giftIdArea: "绑定用户ID区域",
      giftIdTop: "ID礼物上架",
      giftText:
        "礼物上架时间后的下月月底开始，系统将在每个月月底自动判断当月月度充值是否大于等于$500(包括钻石充值和金币充值）,如果不满足则礼物自动下架；如果ID礼物需要重新上架，请在上架后修改ID礼物上架时间；",
      customGiftId: "定制礼物HiloID",
      customGiftIdArea: "定制礼物HiloID区域"
    },
    giftEdit: {
      pleaseContent: "请输入内容",
      giftName: "礼物名称",
      giftIcon: "礼物图标",
      selectImg: "选择图片",
      giftEffect: "礼物特效",
      hasMusic: "是否有音乐",
      // overtimeCredit: "加时额度(秒)",
      gem: "钻石",
      getGem: "产出钻石",
      gemWarn:
        "注意:此处显示的是钻石产出默认值,根据输入的钻石和默认产出比例50%,若产出比例不变,请不要修改该值,若产出比例改变,则需手动计算并修改。",
      gemWarn1:
        "注意:此处显示的是钻石产出默认值,根据输入的钻石和默认产出比例100%,若产出比例不变,请不要修改该值,若产出比例改变,则需手动计算并修改。",
      gemWarn2:
        "注意:此处显示的是钻石产出默认值,根据输入的钻石和默认产出比例5%,若产出比例不变,请不要修改该值,若产出比例改变,则需手动计算并修改。",
      sortShelf: "架上顺序",
      uploadIcon: "上传礼物图标",
      uploadEffect: "上传礼物特效",
      getBeans: "产出豆子",
      getGold: "产出金币",
      giftSubfield: "礼物分栏",
      option1: "常规礼物",
      option2: "CP礼物",
      option3: "国家礼物",
      option4: "专属礼物",
      option8: "幸运礼物",
      giftType: "礼物类型",
      option5: "黄钻礼物",
      option6: "粉钻礼物",
      option7: "活动礼物",
      yellow_price: "黄钻价格",
      powder_price: "粉钻价格"
    },
    reportProcess: {
      tabText1: "举报处理",
      tabText2: "反馈信息",
      reportWay: "举报途径",
      toBeProcessed: "待处理",
      ignore: "忽略",
      ignored: "已忽略",
      banText: "封禁",
      unBanText: "解除用户封禁",
      processed: "已处理",
      unProcessed: "未处理",
      reportDate: "举报日期",
      reportId: "举报ID",
      reportFromName: "举报者昵称",
      reportIdEd: "被举报ID",
      reportIdImg: "被举报ID头像",
      reportIdName: "被举报ID昵称",
      reportCount: "被举报ID累计被举报次数",
      reportLoginIp: "被举报ID登录IP",
      evidence: "相关证据",
      reportType: "举报类型",
      status: "状态",
      videoChat: "视频聊天",
      showDetail: "查看详情",
      history: "历史匹配",
      msgChat: "消息聊天",
      verbalHarassment: "言语骚扰",
      indecentBehavior: "不雅行为",
      badInformation: "不良信息",
      indecentPhoto: "不雅照片",
      isIgnoreWarn: "是否忽略该举报",
      isUnBanWarn: "是否解除封禁",
      feedbackTab1: "日期",
      feedbackTab2: "ID",
      feedbackTab3: "头像",
      feedbackTab4: "昵称",
      feedbackTab5: "反馈图片",
      feedbackTab6: "反馈描述",
      modalBanTitle: "封禁操作",
      userIdLabel: "用户ID",
      reportWay1: "视频匹配",
      reportWay2: "用户主页",
      reportWay3: "会话",
      reportWay4: "匹配历史",
      reportWay5: "群组",
      reportType1: "语言骚扰（verbal harassment）",
      reportType2: "Nudity",
      reportType3: "不良消息",
      reportType4: "不雅图片",
      reportType5: "色情",
      reportType6: "未成年",
      reportType7: "广告",
      reportType8: "其他违规",
      reportType9: "合计"
    },
    userInfomation: {
      userId: "ID",
      oId: "原始ID",
      avatar: "头像",
      nickname: "昵称",
      gender: "性别",
      cluster: "群组ID",
      area: "区域",
      recommendText: "修改推荐",
      gemBalance: "宝石余额",
      beansBalance: "豆子余额",
      tallNobility: "贵族",
      tallNobilityTime: "失效时间",
      createTime: "注册时间",
      connectTotal: "总连接次数",
      effectConnect: "总有效连接次数",
      userScope: "用户分值",
      checkProp: "查看道具",
      setUnionUser: "设为主播",
      unSetUnionUser: "取消主播",
      sendGem: "赠送宝石",
      sendGameMoney: "赠送游戏币",
      seekCluster: "搜索群组",
      connectLog: "连接日志",
      rechargeLog: "充值记录",
      banText: "封禁",
      unUserBanText: "解除用户封禁",
      unDevBanText: "解除设备封禁",
      unDevBanText2: "设备封禁",
      bannedBroadcast: "封禁广播",
      bannedBroadcast1: "解除封禁广播",
      bannedUserSee: "限制广播",
      bannedUserSee1: " 取消限制广播",
      bannedUserSee2: "是否取消限制广播？",
      setUnionUserWarn: "是否设为公会用户",
      unSetUnionUserWarn: "是否取消公会用户",
      sendGemTitle: "赠送宝石",
      sendVIP: "赠送VIP",
      sendProps: "赠送道具",
      propsType: "道具类型",
      propsID: "道具ID",
      propsSum: "数量",
      sendVIPTime: "赠送时间",
      sendNBY: "赠送贵族",
      sendNBYRank: "贵族级别",
      sendNBYTime: "有效时间(天)",
      sendDate: "天",
      sendVIPWarn: "天数需要填写正数或最多两位小数",
      setDataLabel: "可管理用户等级",
      setData: "设为资料管理员",
      delData: "取消无限制资料管理员",
      delData1: "取消10级资料管理员",
      delData2: "取消30级资料管理员",
      delData3: "取消SVIP小于等于【%】资料管理人",
      setManager: "设为广场管理人",
      setManager1: "取消SVIP小于等于【%】广场管理人",
      setManager2: "SVIP小于等于：",
      setManagerWarn: "是否确定删除广场管理人身份？",
      noLimit: "无限制",
      tenStep: "<或=30级",
      delLabel: "是否确定删除资料管理人身份？",
      setRoom: "设为不被踢出房间",
      delRoom: "取消不被踢出房间",
      setRoomWarn: "是否取消不被踢出房间？",
      setMicrophone: "设为麦位管理人",
      delMicrophone: "取消SVIP小于等于【%】麦位管理人",
      setMicrophoneWarn: "是否确定删除麦位管理人身份？",
      setRoomManager: "设为踢出房间管理人",
      delRoomManager: "取消SVIP小于等于【%】踢出房间管理人",
      setRoomManagerWarn: "是否确定删除踢出房间管理人身份？",
      // systemRecharge: "系统充值",
      // internalDist: "内部发放",
      // unionUsers: "工会用户发放",
      gemNum: "宝石数量",
      yxbNum: "游戏币数量",
      // actualAmount: "实际金额",
      // sendType: "类型",
      coinType: "币种",
      sendReason: "赠送原因",
      dollar: "美元",
      yuan: "人民币",
      sendGemError1: "宝石数量不能为空",
      sendGemError2: "实际金额不能为空",
      sendGemError3: "赠送原因不能为空",
      sendGemError4: "填写的内容需要为数字",
      unBanUserCheckText: "确认解除封禁",
      unBanUserCheckText1: "确认封禁设备",
      unBanUserCheckText2: "确认解除封禁广播?",
      notDevImei: "没有设备",
      recommend: "在线推荐",
      recommended: "已推荐",
      checkRecomend: "确认执行推荐操作?",
      checkDelete: "确认执行删除推荐操作?",
      resetText: "重置",
      resetAvatarText: "确认执行重置头像操作",
      expensesRecord: "消费记录",
      diamondIncome: "钻石收入记录",
      photoText: "相册",
      photoDelWarn: "确认执行删除操作",
      userDetail: "详情",
      codeId: "靓号id",
      uploadImg: "点击上传头像",
      pageText1: "修改用户昵称",
      pageText2: "修改用户靓号",
      pageText3: "用户靓号",
      pageText6: "修改财富等级",
      pageText7: "修改魅力等级",
      pageText8: "修改活跃等级",
      pageText9: "ID有效天数",
      pageText10: "SVIP保级要求",
      colorful: "国家炫彩ID",
      pageText4: "确认执行删除该用户靓号id操作",
      pageText5: "该用户没有靓号id",
      groupIdText: "创建的群组id",
      recommendFu: "是否推荐",
      registerTime: "注册时间",
      lastTimeLogin: "最后一次登录时间",
      memorandum: "运营备忘",
      groupMemos: "群组备忘",
      addMemorandum: "添加运营备忘",
      showMemo: "请输入备忘信息",
      exclusive: "卡券类型",
      exclusiveNum: "卡券个数",
      bobExclusive: "贵族卡券",
      text1: "修改性别",
      text2: "国家",
      text3: "修改国家",
      text4: "查看",
      text5: "冻结消费",
      text6: "消费明细",
      text7: "查看明细",

      text8: "豆子明细",
      text9: "钻石明细",
      text10: "已冻结",
      text11: "确认冻结该帐号消费？",
      text12: "确认解冻该帐号消费？",
      text13: "解冻消费",
      text16: "IP账户",
      text17: "同设备账号数",
      text18: "封禁IP",
      text19: "取消封禁IP",
      text20: "用户系统",
      text21: "用户当前版本",
      text22: "是否最新版本",

      broadcastCustodian: "广播管理人",
      addBroadcast: "设为广播管理人",
      delBroadcast: "取消SVIP小于等于【%】广播管理人",
      addBroadcastCustodian: "是否确认设为广播管理人",
      delBroadcastCustodian: "是否确认取消广播管理人",

      association: "公会名",
      addAssociation: "加入公会",

      identity: "身份",
      setIdentity: "设置国家管理员/助理",
      setIntendantAssistant: "设为国家or区域管理员/助理",
      cancelIntendantAssistant: "取消%s",
      setAssistantFu: "是否确认设为国家or区域管理员/助理身份",
      cancelAssistantFu: "是否确认取消国家or区域管理员/助理身份",
      stateAdministrator: "国家管理员",
      nationalAssistant: "国家助理",
      stateAdministrator1: "区域管理员",
      nationalAssistant1: "区域助理",

      deleteUnionFu: "是否确认取消主播",

      setIntendant: "设为超级管理",
      unsetIntendant: "取消超级管理",
      haveBeenIntendant: "超级管理身份",
      setIntendantWarn: "是否确认设为超级管理",
      unsetIntendantWarn: "是否确认取消超级管理",
      sendNobility: "赠送贵族",
      quitInfluence: "退出家族",
      unQuitInfluence: "是否确认退出家族",
      deleteProp: "是否确认删除",
      deletePropAudit: "是否确认删除该审核数据",

      propDetail: "道具详情",
      propType: "道具类型",
      propName: "道具名称",
      propTime: "有效时间",

      nobility: "贵族",
      medal: "勋章",
      headWear: "头饰",
      vehicle: "座驾",
      bagGift: "背包礼物",

      bindingIphone: "绑定手机",
      iphoneText: "请输入绑定手机号",
      bindingPwd: "设置密码",
      pwdText: "请输入密码",
      isWhite: "加入登录白名单",
      birthday: "出生日期",
      createCode: "创建成功",

      income1: "日期",
      income2: "ID",
      income3: "昵称",
      income4: "钻石收入",
      income5: "收入类型",
      income6: "金额",
      income7: "请输入金额",

      daySum: "请输入扣除的天数，输入0则为全部扣除",
      pcsSum: "请输入扣除的个数，输入0则为全部扣除",
      permissionScope: "权限范围",

      cfLevel: "财富等级",
      mlLevel: "魅力等级",
      hyLevel: "活跃等级",
      svip_tab1: "当前SVIP等级",
      svip_tab2: "当前SVIP积分",
      svip_tab3: "距离下一个等级需要积分",
      svip_tab4: "保级需要积分",
      svip_tab5: "SVIP过期时间",
      svip_tab6: "修改svip等级",
      svip_tab7: "延长过期时间",
      svip_tab8: "svip等级",
      svip_tab9: "有效期",
      svip_tab10: "用户的SVIP等级修改为svip%s，过期时间为%d,是否确定修改?",
      svip_tab11: "用户的SVIP%s过期时间延长到%d,是否确定修改?",
      svip_tab12: "增加svip积分",
      svip_tab13: "增加积分数",
      svip_tab14: "增加积分后,用户的SVIP等级为svip%s,积分为%d,是否确定修改?",
      svip_tab15: "扣除svip积分",
      svip_tab16: "扣除积分数",
      svip_tab17: "扣除积分后,用户的SVIP等级为svip%s,积分为%d,是否确定修改?",
      svip_tab18: "历史svip 最高等级"
    },
    roomActivity: {
      search1: "创建活动",
      list_title1: "活动ID",
      list_title2: "Banner",
      list_title3: "活动名称",
      list_title4: "开始时间",
      list_title5: "结束时间",
      list_title6: "单笔充值要求",
      list_title7: "奖励礼物ID",
      list_title8: "奖励礼物图",
      list_title9: "礼物价格",
      list_title10: "礼物数量",
      list_title11: "总礼物价值",
      list_title12: "活动奖杯要求",
      list_title13: "活动支持者要求",
      list_title14: "礼物天数",
      list_title15: "活动状态",
      list_title16: "是否上架该活动",
      list_title17: "是否下架该活动",
      list_title18: "区域",

      list2_title1: "发放编号",
      list2_title2: "活动名称",
      list2_title3: "房间Banner",
      list2_title4: "Hilo ID",
      list2_title5: "国家",
      list2_title6: "单笔充值金额",
      list2_title7: "房间活动奖杯",
      list2_title8: "房间活动支持者",
      list2_title9: "代理ID",
      list2_title10: "代理发放时间",
      list2_title11: "发送总礼物价值",

      list3_title1: "操作模块",
      list3_title2: "请选择模块",
      list3_title3: "操作时间",
      list3_title4: "操作内容",
      list3_title5: "ID升级",
      list3_title6: "绑定手机号码",
      list3_title7: "创建家族",
      list3_title8: "充值要求类型",
      list3_title9: "单笔充值",
      list3_title10: "单笔以上充值",
      list3_title11: "任务配置",
      list3_title12: "发放条件",
      list3_title13: "累计充值",
      list3_title14: "房间奖杯",
      list3_title15: "SVIP等级",
      list3_title16: "发放条件数值",
      list3_title17: "财富等级",
      list3_title18: "财富等级数值",
      list3_title19: "2024年起累积充值",
      list3_title20: "家族等级",
      list3_title21: "活跃等级"
    },
    activityReboot: {
      reb1: "上麦幸运礼包",
      reb2: "限时挑战",
      reb3: "锦标赛",
      reb4: "大赢家",
      reb5: "水果机（分赛道）",
      reb6: "赛车游戏",
      reb7: "常规Slot",
      reb8: "candy",
      reb9: "活动类型",
      reb10: "游戏类型",
      reb11: "Foodie游戏",
      reb12: "Jackpot游戏",
      reb13: "头号玩家",
      reb14: "fruit77",
      reb15: "吉尼斯挑战赛",
      reb16: "许愿树",
      reb17: "充值赢红包",
      reb18: "女性戒指",
      reb19: "男性西装",
      reb20: "戒指女王",
      reb21: "宝石女王",
      reb22: "项链女王",
      reb23: "绅士的西装",
      reb24: "绅士的腕表",
      reb25: "女性主题",
      reb26: "男性主题",
      reb27: "男女戒指",
      reb28: "充值送道具",
      reb29: "充值送大礼包",
      reb30: "美食家（分赛道）",
      reb31: "足球（分赛道）",
      reb32: "抢头条",
      reb33: "主题"
    },
    activityPopup: {
      reb1: "限时单笔充值活动"
    },
    connectionLog: {
      export: "导出",
      connectTime: "连接时间",
      connectId: "ID",
      connectToId: "连接到ID",
      connectDuration: "连接时长(秒)",
      nowConnect: "本次连接中消费的礼物价值(宝石)"
    },
    topUpLog: {
      topUpId: "ID",
      nickname: "昵称",
      topUpTime: "充值时间",
      topUpType: "充值类型",
      topUpNum: "充值金额(美元)",
      topUpEffect: "消费有效期",
      VIPText: "VIP",
      gem: "宝石",
      gemRecharge: "宝石充值",
      tab1: "日统计",
      tab2: "周统计",
      tab3: "月统计",
      tab4: "充值明细",

      sendType1: "发送礼物",
      sendType2: "匹配条件",
      sendType3: "建立融云会话",
      sendType4: "购买钻石",
      sendType5: "接受礼物",
      sendType6: "注册",
      sendType7: "平台赠送",

      updateText1: "充值到账时间",
      updateText2: "到账用户ID",
      updateText3: "到账用户姓名",
      updateText4: "到账金额（美元）",
      updateText5: "支付类型",
      updateText6: "订单号",

      updateText7: "日期",
      updateText8: "用户ID",
      updateText9: "用户昵称",
      updateText10: "当日统计",
      updateText11: "周统计",
      updateText12: "月统计",
      updateText13: "国家",
      updateText14: "支付货币"
    },
    riskManagement: {
      userId: "用户ID",
      userText: "请输入用户ID",
      tab1: "日统计",
      tab2: "周统计",
      tab3: "月统计",
      tab4: "退款明细",
      tab5: "充值黑白名单",

      updateText1: "退款时间",
      updateText2: "用户ID",
      updateText3: "用户昵称",
      updateText4: "退款金额",
      updateText5: "退款钻石数",
      updateText6: "退款订单号",
      updateText13: "充值时间",
      updateText14: "累积退款金额",

      updateText7: "日期",
      updateText8: "退款用户数",
      updateText9: "退款金额",

      roll1: "用户ID",
      roll2: "昵称",
      roll3: "国家",
      roll4: "注册时间",
      roll5: "最后登陆时间",
      roll6: "是否拦截",
      roll7: "拦截渠道",
      roll8: "钻石余额",
      roll9: "注册IP（账户数）",
      roll10: "设备码（账户数）",
      roll11: "添加时间",
      rollToast: "是否删除该名单",
      rollAdd: "新增充值黑白名单",
      rollBanIp: "将ip加入风险控制",
      rollBanImei: "将机器码加入风险控制",
      roll12: "Apple",
      roll13: "Google",
      roll14: "官网"
    },
    deviceBlacklist: {
      device1: "设备码",
      device2: "设备识别号",
      device3: "查询",
      device4: "新增",
      device5: "请输入设备码",
      device6: "ID",
      device7: "封禁原因",
      device8: "设备当前账号数",
      device9: "操作人",
      device10: "添加时间",
      device11: "操作",
      device12: "设备封禁",
      device13: "移除",
      device14: "是否确认移除，移除即能登录",
      device15: "封禁描述",
      device16: "",
      device17: "",
      device18: "",
      device19: "",
      device20: ""
    },
    ipBlacklist: {
      device1: "IP地址",
      device2: "IP识别号",
      device3: "查询",
      device4: "新增",
      device5: "请输入IP地址",
      device6: "ID",
      device7: "封禁原因",
      device8: "IP当前账号数",
      device9: "操作人",
      device10: "添加时间",
      device11: "操作",
      device12: "IP封禁",
      device13: "移除",
      device14: "是否确认移除，移除即能登录",
      device15: "封禁描述",
      device16: "",
      device17: "",
      device18: "",
      device19: "",
      device20: ""
    },
    ipLog: {
      text1: "全部永久封禁",
      text2: "封禁选择账户",
      text3: "ID",
      text5: "昵称",
      text6: "国家",
      text7: "设备码",
      text8: "财富等级",
      text9: "魅力等级",
      text10: "活跃等级",

      text11: "注册IP",
      text12: "注册时间",
      text13: "最后登陆时间",

      text14: "关联IP数",
      text15: "关联IP账号数",
      text16: "关联设备数",
      text17: "关联设备账号数"
    },
    expensesRecord: {
      table1Text1: "消费时间",
      table1Text2: "消费ID",
      table1Text3: "消费ID昵称",
      table1Text4: "消费类型",
      table1Text5: "宝石数",
      table1Text6: "被赠送ID",
      table1Text7: "被赠送ID昵称",
      table1Text8: "说明",

      table1Select1: "随机匹配送礼物",
      table1Select2: "性别筛选",
      table1Select3: "国家筛选",
      table1Select4: "购买对话",
      table1Select5: "1V1视频",
      table1Select6: "1V1视频送礼物",
      table1Select7: "创建会话",
      table1Select8: "会话中送礼物",

      text1: "获得时间",
      text2: "获得ID",
      text3: "获得ID昵称",
      text4: "获得类型",
      text5: "赠送ID",
      text6: "赠送ID昵称",

      text7: "随机匹配收到礼物",
      text8: "群组礼物",
      text9: "会话中收到礼物",
      text10: "群组送礼",
      text11: "随机匹配收到礼物",

      newText: "",
      newText4: "购买钻石",
      newText5: "收礼物",
      newText6: "注册奖励",
      newText8: "平台赠送",
      newText10: "平台扣除",
      newText11: "活动榜单",
      newText12: "豆子兑换",
      newText13: "群组活动榜单",
      newText14: "每日登陆领取钻石",
      newText15: "群主IM群发",
      newText16: "每日登陆领取钻石（普通用户）",
      newText17: "群组支持钻石利益分配者(不是东八区，不能每天一次)",
      newText18: "群组支持钻石管理者(不是东八区，不能每天一次)",
      newText19: "管理人单子批量送钻石",
      newText20: "购买头饰",
      newText21: "购买座驾",
      newText22: "参与转盘扣费",
      newText23: "转盘取消退钱",
      newText24: "转盘获胜奖励",
      newText25: "转盘群主提成",
      newText26: "币商转账",
      newText27: "购买群组自定义主题",
      newText28: "火箭奖励",
      newText29: "购买幸运盒子",
      newText30: "幸运盒子奖励",
      newText31: "私聊送礼物",
      newText32: "私聊送礼物退款",
      newText33: "活动阀值触发奖励",
      newText34: "1对1公会视频送礼物",
      newText35: "1对1公会视频送礼物退款",
      newText36: "发布全球消息",
      newText37: "任务奖励",
      newText38: "水果机奖励",
      newText39: "果机投注",
      newText40: "发红包",
      newText41: "加入游戏扣费",
      newText42: "赛车投注",
      newText43: "创建群组活动"
    },
    guildUsers: {
      searchInfo: "信息查询",
      indicator: "指标统计",
      workStatus: "工作状态",
      unWorkStatus: "非工作状态",
      titleDate: "日期",
      avatar: "头像",
      nickname: "昵称",
      gender: "性别",
      area: "区域",
      // matchLogRecord: "匹配池记录",
      // matchNum: "匹配推送数",
      isVip: "是否VIP",
      status: "状态",
      connect: "昨天有效连接次数",
      connectTime: "昨天连接时间(秒)",
      giftValue: "昨天获得礼物价值(豆子)",
      vipExpire: "VIP到期时间",
      cancelGuild: "取消公会用户",
      hasNoGuild: "已非公会用户",
      connectLog: "连接日志",
      // totalConnect: "总达标连接次数",
      // totalConnectTime: "总达标连接时间(秒)",
      // timeOnmic: "上麦时长(分钟)",
      // totalGiftValue: "总获得礼物价值(豆子)",
      yesterday: "昨天",
      thisWeek: "本周",
      lastWeek: "上周",
      thisMonth: "本月",
      lastMonth: "上个月",
      endNotMoreStart: "开始时间不能大于结束时间",
      startNotNull: "开始时间不能为空",
      setUnionUserWarn: "是否设为公会用户",
      unSetUnionUserWarn: "是否取消公会用户",
      setUnionUser: "设为公会用户",
      unSetUnionUser: "取消公会用户",
      startTimeOrEndTime: "开始时间或结束时间不能为空",
      matchPush: "匹配推送数",
      // connectPhone: '接通电话数',
      connectPhone: "连接次数",
      connectRate: "接通率",
      totalVideoTime: "连接时长 min",

      matchPoolTable1: "批次号",
      matchPoolTable2: "推送批次时间",
      matchPoolTable3: "匹配池用户数(人)",
      agentText: "代理",
      reductD: "扣除钻石",
      editAgein: "修改公会", // 编辑代理
      uploadArr: "上传封面",
      anchorImg: "主播封面",
      uploadArrFu: "是否确认更新公会用户头像",
      diamonNum: "钻石余额",
      deleteDiamon: "扣除钻石",
      deleteDiamonText: "扣除钻石数量",
      deleteGoldText: "扣除金币数量",
      diamonNotNull: "钻石数量不能为空",
      goldNotNull: "金币数量不能为空",
      agentNotNull: "代理名字不能为空",
      editSCID: "编辑SCID",
      scidText: "SCID",
      scidNotNull: "SCID不能为空",
      scidWarnText: "SCID需要为整数",
      text1: "豆子余额",
      text2: "扣除豆子",
      text3: "扣除豆子数量",
      text4: "扣除豆子数量不能为空",
      text5: "批量扣除豆子",
      text6: "豆子扣除记录",

      text7: "清零日期时间",
      text8: "用户ID",
      text9: "用户昵称",
      text10: "代理",
      text11: "清零豆子余额",
      text12: "操作人",
      // text13: "喜欢",

      text14: "公会ID",
      text15: "新增金币数",
      text16: "在线时长 min",
      text17: "录入时间",
      text18: "主播ID",
      text19: "公会名",

      text20: "批量扣除金币",
      text21: "金币扣除记录",
      text22: "扣除金币",
      text23: "代理ID",
      text24: "同IP账户数",
      text25: "同设备账户数",
      text26: "录入时间",
      text27: "金币余额",
      text28: "代理ID",
      text29: "清零金币余额"
    },
    guildConnectionLog: {
      export: "导出",
      connectTime: "连接时间",
      connectId: "ID",
      connectToId: "连接到ID",
      connectDuration: "连接时长(秒)",
      nowConnect: "公会用户礼物实际收入（豆子）",
      status: "状态",
      effectLink: "达标连接",
      unEffectLink: "不达标连接",
      pic: "截图",
      videoRecord: "视频录制",
      linkType: "连接类型",
      linkType1: "随机匹配",
      linkType2: "融云会话中场景",
      linkType3: "1v1视频"
    },
    statistics: {
      tab1: "日统计",
      tab2: "周统计",
      tab3: "月统计",
      tab4: "总统计",
      allCountry: "全部国家/地区",
      daily: "日期",
      dau: "日活DAU",
      daySave: "次日留存",
      newRegister: "新注册数",
      todayCustom: "当日消费明细",
      todayIncome: "当日预估收入",
      todayBuyUser: "当日购买VIP用户数",
      todayCharge: "当日充值用户数",
      todayChargeNum: "当日充值次数",

      wau: "周活跃WAU",
      sevenDaySave: "7日留存",
      weekNewRegister: "本周新注册数",
      weekCustom: "本周消费明细",
      weekIncome: "本周预估收入",
      weekBuyUser: "本周购买VIP用户数",
      weekCharge: "本周充值用户数(宝石)",
      weekChargeNum: "本周充值次数(宝石)",
      weekPayRate: "本周付费率",
      weekAPRU: "本周美元APRU",

      mau: "月活MAU",
      monthSave: "30日留存",
      monthNewRegister: "本月新注册数",
      monthCustom: "本月消费明细",
      monthIncome: "本月预估收入",
      monthBuyUser: "本月购买VIP用户数",
      monthCharge: "本月充值用户数(宝石)",
      monthChargeNum: "本月充值次数(宝石)",
      monthPayRate: "本月付费率",
      monthAPRU: "本月美元APRU",

      userNum: "用户数",
      vipUserNum: "VIP用户数",
      nowVipUserNum: "当前Vip用户数",
      totalVipCustom: "累积VIP消费金额(美元)",
      totalCharge: "充值用户数(宝石)",
      totalChargeNum: "累积充值金额(美元)",
      totalConsump: "消费明细",
      totalncome: "预估收入",
      totalPayRate: "付费率",
      totalAPRU: "美元APRU"
    },
    operationalData: {
      tab1: "日统计",
      tab2: "周统计",
      tab3: "月统计",
      tab4: "充值明细",
      tab5: "总统计",
      tab6: "消费统计",
      tab7: "VIP购买明细",
      allCountry: "全部国家/地区",
      date: "日期",
      dateDAU: "日活DAU",
      yesterday: "次日留存",
      yesterdayRate: "次日留存率",
      loginNum: "新注册数",
      todayUse: "当日钻石消费明细",
      todayIncome: "当日预估收入",
      todayTotal: "当日钻石消费合计",
      todayVIP: "当日购买VIP用户数",
      todayRecharge: "当日钻石充值用户数",
      todayRechargeNum: "当日钻石充值次数",
      todayUseIcon: "当日金币消费明细",
      todayTotalIcon: "当日金币消费合计",
      daySum: "当日总消费",
      todayRechargeIcon: "当日金币充值用户数",

      weekWAU: "周活跃WAU",
      weekSave: "周留存",
      weekTotal: "本周钻石消费合计",
      weekSaveRate: "周留存率",
      wLoginNum: "本周新注册数",
      wUse: "本周钻石消费明细",
      wIncome: "本周预估收入",
      wVip: "本周购买VIP用户数",
      wRecharge: "本周钻石充值用户数",
      wRechargeNum: "本周钻石充值次数",
      wRate: "本周付费率",
      wAPRU: "本周美元APRU",
      weekTotalIcon: "本周金币消费合计",
      wUseIcon: "本周金币消费明细",
      weekSum: "本周总消费",
      wRechargeIcon: "本周金币充值用户数",

      monthMAU: "月活MAU",
      monthSave: "月留存",
      monthTotal: "本月钻石消费合计",
      monthSaveRate: "月留存率",
      mLoginNum: "本月新注册数",
      mUse: "本月钻石消费明细",
      mIncome: "本月预估收入",
      mVip: "本月购买VIP用户数",
      mRecharge: "本月钻石充值用户数",
      mRechargeNum: "本月钻石充值次数",
      mRate: "本月付费率",
      mAPRU: "本月美元APRU",
      monthTotalIcon: "本月金币消费合计",
      mUseIcon: "本月金币消费明细",
      monthSum: "本月总消费",
      mRechargeIcon: "本月金币充值用户数",

      totalNum: "用户数",
      vipNum: "VIP用户数",
      nowVip: "当前VIP用户数",
      vipUse: "累积VIP消费金额(美元)",
      rechargeUseNum: "充值用户数(宝石)",
      rechargeNum: "累积充值金额(美元)",
      consumDetail: "消费明细",
      income: "预估收入",
      payRate: "付费率",
      dollerAPRU: "美元APRU",

      applePay: "苹果支付",
      googlePay: "谷歌支付",
      officialPay: "官网支付", // 原本是官网充值
      officialPay_Pay: "官网支付",
      eggplantPay: "代理支付", // 原本是茄子支付
      agencyPay: "代理充值",
      cloudSky_Pay: "空中云汇",

      applePay_pink: "苹果支付(金币)",
      googlePay_pink: "谷歌支付(金币)",
      officialPay_pink: "官网支付(金币)", // 原本是官网充值
      officialPay_Pay_pink: "官网支付(金币)",
      eggplantPay_pink: "代理支付(金币)", // 原本是茄子支付

      effectLinkNum: "视频连接次数（正常结束）",
      vedioNum: "进行视频人数",

      table4Text1: "充值到账时间",
      table4Text2: "到账用户ID",
      table4Text3: "到账用户姓名",
      table4Text4: "到账金额(美元)",
      table4Text5: "支付类型",
      table4Text6: "订单号",
      table4Text7: "国家",
      table4Text8: "支付货币",
      payType: "支付类型",
      agreedToVideo: "视频连接次数（双方同意）",

      table5Text1: "日期",
      table5Text2: "系统发放钻石",
      table5Text3: "用户充值钻石",
      table5Text4: "群组礼物钻石流水",
      table5Text5: "IM礼物钻石流水",
      table5Text6: "转盘钻石流水",
      table5Text7: "随机视屏礼物钻石流水",
      table5Text8: "1v1视屏礼物钻石流水",

      table6Text1: "购买到账时间",
      table6Text2: "当日全渠道钻石充值用户数",
      table6Text3: "本周全渠道钻石充值用户数",
      table6Text4: "本月全渠道钻石充值用户数"
    },
    // 充值代理管理
    topUpAgentData: {
      tab1: "信息管理",
      tab2: "黄钻充值记录",
      tab3: "粉钻充值记录",
      tab4: "黄钻销售记录",
      tab5: "粉钻销售记录",
      tab6: "设置促销员",
      tab7: "促销员ID",
      tab8: "单笔充值最高金额",
      tab9: "二级代理管理",
      tab10: "新增二级代理",
      tab11: "分销明细",
      tab12: "编辑二级代理",
      tab13: "扣除代理币",
      // 信息管理列表
      Id: "ID",
      listAgencyId: "代理ID",
      agencyHead: "头像",
      agencyName: "昵称",
      accumulateSell: "累积销售总额（美元）",
      accumulateRecharge: "累积充值总额（美元）",
      WeChat: "微信",
      Whatsapp: "Whatsapp",
      dockingPeople: "主要对接人",
      status: "状态",
      isFrozen: "代理账户状态",
      isFrozen_1: "正常",
      isFrozen_2: "冻结",
      isFrozen_3: "解冻",
      whetherUnFrozen: "是否确认【解冻】代理账户",
      whetherFrozen: "是否确认【冻结】代理账户",
      agencyOperate: "操作",
      // 充值记录列表
      rechargeCode: "充值编号",
      provideTime: "发放时间",
      rechargeAgencyId: "代理ID",
      rechargeHead: "头像",
      rechargeName: "昵称",
      provide: "发放人",
      friendRecharge: "邀请好友充值ID",
      friendRechargeFu: "是否支持邀请好友充值",
      familyAgency: "是否设置为家族代理",
      agencyCountry: "是否允许代理修改国家",
      countryMarket: "是否限制区域内国家销售",
      topUpDiamond: "充值黄钻",
      topUpDiamondF: "充值粉钻",
      topUpSum: "充值金额（美元）",
      topUpSumNative: "充值金额（本地货币）",
      payment: "支付方式",
      // 销售记录列表
      sellId: "代理ID",
      sellHead: "头像",
      sellName: "昵称",
      sellDiamond: "钻石余额",
      dealerLevel: "代理等级",
      LevelOne: "一级代理",
      LevelTwo: "二级代理",
      IsFamilyAgent: "代理属性",
      IsFuOne: "普通代理",
      IsFuTwo: "家族代理",
      rechargeAmount: "黄钻充值金额（美元）",
      marketNumber: "黄钻销售人数",
      marketMoney: "黄钻销售金额",
      rechargeAmountF: "粉钻充值金额（美元）",
      marketNumberF: "粉钻销售人数",
      marketMoneyF: "粉钻销售金额",
      vepTransferNum: "二级代理销售人数",
      vepTransferMoney: "二级代理销售金额",
      vepTransferMoneyNum: "总黄钻销售金额",
      country: "国家",
      abutmentLabel: "对接人",
      insider1: "黄蕾",
      insider2: "迪丽",
      insider3: "陈诺",
      insider4: "欧小妹",
      insider5: "杨辉云",
      insider6: "陈梦婷",
      sellOperate: "操作",
      //销售明细
      agentUserId: "用户ID",
      agentUserHead: "头像",
      agentUserCall: "昵称",
      agentUserSum: "充值金额（美元）",
      agentUserGem: "充值黄钻",
      agentUserGemF: "充值粉钻",
      agentUserTime: "充值时间",

      agencyId: "请输入一级或二级代理ID",
      agencyId2: "请输入促销员ID",
      isUp: "已上架",
      unUp: "未上架",
      all: "全部",
      search: "搜索",
      addAgent: "新增代理",
      editAgent: "编辑代理",
      agentRecharge: "代理黄钻充值",
      agentRechargePink: "代理粉钻充值",

      putAway: "上架",
      outAway: "下架",
      salesDetails: "销售明细",
      whetherPutAway: "是否确认上架代理",
      whetherOutAway: "是否确认下架代理",

      agentRegion: "代理区域",
      tagLabel: "设置标签",
      tagLabel2: "区域代理",
      tagLabel3: "家族代理",
      tagLabel4: "国家代理",

      agent_li1: "代理自充",
      agent_li2: "邀请好友充值",
      agent_li3: "运营手动充值",
      agent_li4: "邀请充值好友ID",

      agent_li5: "一级代理ID",
      agent_li6: "二级代理ID",
      agent_li7: "一级代理昵称",
      agent_li8: "二级代理昵称",
      agent_li9: "转账金额（美元）",
      agent_li10: "转账钻石",
      agent_li11: "二级代理国家",
      agent_li12: "",

      ch_li1: "编号",
      ch_li2: "代理ID",
      ch_li3: "扣除货币类型",
      ch_li4: "扣除金额",
      ch_li5: "扣除原因",
      ch_li6: "扣除时间",
      ch_li7: "代理钻石",
      ch_li8: "代理金币",
      ch_li9: "扣除代理钻石",
      ch_li10: "扣除代理金币",
      ch_li11: "扣除钻石数额",
      ch_li12: "扣除金币数额"
    },
    // 新用户奖励审核
    newUserAudit: {
      tab1: "新用户审核",
      tab2: "邀请人统计",
      tab3: "待审核",
      tab4: "已审核",
      tab5: "日统计",
      tab6: "周统计",
      tab7: "月统计",
      tab8: "已通过",
      tab9: "已拒绝",
      tab10: "区域统计",
      tab11: "人员审核统计",

      d_list1: "ID",
      d_list2: "国家",
      d_list3: "等级",
      d_list4: "充值金额",
      d_list5: "注册时间",
      d_list6: "同IP账号数",
      d_list7: "同设备账号数",
      d_list8: "申请时间",
      d_list9: "邀请人ID",
      d_list10: "在其它app截图",
      d_list11: "商店评分截图",

      y_list1: "ID",
      y_list2: "国家",
      y_list3: "等级",
      y_list4: "充值金额",
      y_list5: "注册时间",
      y_list6: "同IP账号数",
      y_list7: "同设备账号数",
      y_list8: "申请时间",
      y_list9: "邀请人ID",
      y_list10: "在其它app截图",
      y_list11: "商店评分截图",
      y_list12: "状态",
      y_list13: "审核人",
      y_list14: "审核时间",

      t_list1: "日期",
      t_list2: "邀请人ID",
      t_list3: "邀请用户通过数量",
      t_list4: "查看详情",
      t_list5: "",
      t_list6: ""
    },
    groupAudit: {
      tab1: "待审核",
      tab2: "已审核",
      tab3: "全部活动",
      tab4: "群组活动奖励审核",
      tab5: "群组活动奖励统计",
      tab6: "日统计",
      tab7: "周统计",
      tab8: "月统计",
      tab9: "国家",

      s_select1: "国家",
      s_select2: "活动类型",
      s_select3: "活动频次",
      s_select4: "首次活动",
      s_select5: "常规活动",
      s_select6: "开始时间",
      s_select7: "结束时间",
      s_select8: "请输入用户ID",
      s_select9: "查询",
      s_select10: "批量通过",
      s_select11: "批量拒绝",
      s_select12: "游戏",
      s_select13: "比赛",
      s_select14: "派对",
      s_select15: "诗歌",
      s_select16: "已通过",
      s_select17: "已拒绝",
      s_select18: "是否执行【批量通过】操作",
      s_select19: "是否执行【批量拒绝】操作",

      tab_list1: "全选",
      tab_list2: "活动banner",
      tab_list3: "用户ID",
      tab_list4: "群组ID",
      tab_list5: "活动流水",
      tab_list6: "活动奖励钻石",
      tab_list7: "支持人数",
      tab_list8: "活动标题",
      tab_list9: "活动描述",
      tab_list10: "活动开始时间",
      tab_list11: "当周活动次数",
      tab_list12: "国家",
      tab_list13: "是否首次活动",
      tab_list14: "活动类型",
      tab_list15: "状态",
      tab_list16: "审核人",
      tab_list17: "审核时间",

      t_list1: "日期",
      t_list2: "申请举办活动数",
      t_list3: "首场活动申请数",
      t_list4: "首场活动达标数",
      t_list5: "常规活动申请数",
      t_list6: "常规活动达标数",
      t_list7: "总达标活动数",
      t_list8: "",
      t_list9: "",
      t_list10: ""
    },
    coinStatistics: {
      list1: "日期",
      list2: "每日兑换金币人数",
      list3: "每日兑换金币数额",
      list4: "运营后台发放",
      list5: "合计",
      list6: "金币回收合计"
    },
    // 信息管理列表(弹出框)
    AgentManage: {
      addGiftBtn: "新增代理",
      editGift: "编辑代理信息",
      agentAdd: "代理充值"
    },
    AgentEdit: {
      pleaseContent: "请输入内容",
      agentNameId: "代理ID",
      agentIctrIp: "微信",
      agentWhatsappName: "Whatsapp",
      buttJoint: "主要对接人",
      authorityCode: "官方账号",
      correspondingCode: "对应官方账号"
    },
    currEdit: {
      pleaseContent: "请输入内容",
      currId: "代理ID",
      currDrill: "充值黄钻",
      currDrillF: "充值粉钻",
      currSum: "充值金额(美元)",
      currPay: "支付方式"
    },
    matchLog: {
      tableText1: "推送批次时间",
      tableText2: "成功批对(对)",
      tableText3: "匹配池用户数(人)",
      tableText4: "落单用户数(人)",
      tableText5: "优先级队列",
      tableText6: "质量队列",
      detailText: "详情",
      searchText1: "批次号"
    },
    // 批次对详情页 (列表 进入 成功批对)
    matchLogSDetail: {
      tableText1: "优先用户ID",
      tableText2: "匹配用户ID",
      tableText3: "优先级总分",
      tableText4: "匹配总分",
      tableText5: "质量总分",
      tableText6: "关系总分",
      tableText7: "离线匹配",
      searchText1: "批次号",
      searchText2: "用户id",
      searchText3: "请输入批次号"
    },
    // 优先级总分详情页 (批次对详情页 进入 优先级总分详情页)
    matchPriority: {
      tableText1: "用户ID",
      tableText2: "用户优先级总分",
      tableText3: "连续被拒分值",
      tableText4: "连续同性分值",
      tableText5: "新用户分值",
      tableText6: "每天新登录用户分值",
      tableText7: "活跃等级分值",
      tableText8: "VIP用户分值",
      tableText9: "首充用户分值(近24小时内首充)",
      tableText10: "钻石余额分值",
      tableText11: "近期充值分值(近30天内)",
      tableText12: "财富等级分值",
      tableText13: "被举报分值(近30天内)",
      tableText14: "被拉黑分值(近30天内)",
      tableText15: "公会用户",
      activeLevel: "活跃等级",
      scope: "分",
      time: "次",
      effectLink: "有效连接次数",
      diamon: "钻石余额",
      wealthLevel: "财富等级"
    },
    // 质量总分详情页(批次对详情页 进入)
    qualityPage: {
      tableText1: "用户ID",
      tableText2: "用户质量总分",
      tableText3: "接通率分值",
      tableText4: "加时率分值",
      tableText5: "接受礼物钻石数量分值",
      tableText6: "接受礼物次数分值",
      tableText7: "魅力等级分值",
      tableText8: "被付费消息次数分值",
      tableText9: "被喜欢次数分值",
      tableText10: "被举报次数分值",
      tableText11: "被拉黑次数分值",
      tableText12: "公户用户分值",
      addTime: "加时率",
      scope: "分",
      time: "次",
      diamon: "钻石",
      connect: "接通率",
      level: "魅力等级"
    },
    // 关系总分详情页（批次对详情页 进入）
    relationTotalPage: {
      tableText1: "优先用户ID",
      tableText2: "匹配用户ID",
      tableText3: "关系总分",
      tableText4: "喜欢分值",
      tableText5: "付费消息但未视频聊天分值",
      tableText6: "匹配过用户(近30天内)",
      tableText7: "拒绝过用户(近30天内)",
      tableText8: "上一轮匹配推送过的用户"
    },
    matchLogRelationTop: {
      tableText1: "用户ID",
      tableText2: "匹配用户",
      tableText3: "匹配总分",
      tableText4: "质量总分",
      tableText5: "关系总分"
    },
    matchLogOrder: {
      tableText1: "落单用户ID",
      tableText2: "匹配ID"
    },
    // 群组扶持
    groupSupport: {
      tab1: "群组扶持统计",
      tab2: "群组扶持明细",

      tab2text1: "群组国家",
      tab2text2: "群组贡献",
      tab2text3: "群组支持者数量",
      tab2text4: "群组扶持等级",
      tab2text5: "是否已经领取奖励",
      tab2text6: "已领取",
      tab2text7: "未领取",
      tab2text8: "群组等级",
      tab2text9: "群组热度",
      tab2text10: "国家"
    },
    // 女孩扶持
    girlSupport: {
      tab1: "女孩审核",
      tab2: "女孩数据",
      tab3: "待审核",
      tab4: "已审核",
      tab5: "支持者人数",
      tab6: "收票数",
      tab7: "上麦时长 h",
      tab8: "审核",

      tabText1: "用户ID",
      tabText2: "国家",
      tabText3: "财富等级",
      tabText4: "家族名称",
      tabText5: "上麦时长  h",
      tabText6: "支持者人数",
      tabText7: "收票数",
      tabText8: "报名时间",
      tabText9: "家族长ID",
      tabText10: "与大R的关系类型",
      tabText11: "关联大R的ID",
      tabText12: "审核结果",
      tabText13: "再次审核",
      tabText14: "已通过",
      tabText15: "已拒绝",
      tabText16: "通过",
      tabText17: "拒绝",

      tabText18: "大R的CP",
      tabText19: "大R的好友",
      tabText20: "自己是大R",
      tabText21: "拒绝原因",
      tabText22: "申请审核中",
      tabText23: "与大R关系",
      tabText24: "虚假账号",
      tabText25: "重复报名",
      tabText26: "没有支持者",
      tabText27: "审核人",
      tabText28: "审核时间"
    },
    // 国家势力
    nationalPower: {
      text1: "新增势力",
      text2: "国家势力ID",
      text3: "国家势力名称",
      text4: "国家势力群组ID",
      text5: "国家势力管理ID",
      text6: "编辑势力",
      text7: "新增势力",
      text8: "势力头像",
      text14: "是否确认解散:",
      text15: "解散",

      new_text1: "家族长ID",
      new_text2: "新增家族",
      new_text3: "家族名称",
      new_text4: "家族头像",
      new_text5: "经验值",
      new_text6: "家族房间流水",
      new_text7: "成员数",
      new_text8: "成员充值 $",
      new_text9: "新成员数",
      new_text10: "新成员充值 $",
      new_text11: "家族铭牌",
      new_text12: "编辑家族",
      new_text13: "家族群组ID",
      new_text14: "家族国家",
      new_text15: "家族区域",
      new_text16: "SVIP成员数"
    },
    agentList: {
      tableText1: "公会ID",
      tableText2: "公会名",
      btn1: "添加公会",
      btn2: "编辑公会",
      checkDelAgent: "确认执行删除操作",
      tableText3: "公会长ID",
      tableText4: "公会长昵称",
      btn3: "设置公会长",
      modalText1: "公会长Hilo账号ID",
      idNotNull1: "公会长Hilo账号ID不能为空",
      btn4: "删除该公会长",
      adminIdNotNullWarn: "确认删除该公会长",
      tableText5: "主播数",
      tableText6: "录入时间"
    },
    eventManagement: {
      tableText1: "座驾ID",
      tableText2: "座驾名称",
      tableText3: "座驾展示图片",
      tableText4: "URL",
      tableText5: "上架",
      tableText6: "下架",
      tableText7: "保存",
      tableText8: "确认下架该座驾",
      tableText9: "确认上架该座驾",
      tableText10: "新增座驾",
      tableText11: "编辑座驾",
      tableText12: "上传座驾图片",
      tableText13: "开始时间",
      tableText14: "结束时间",
      tableText15: "开始时间或结束时间不能为空",
      tableText16: "结束时间不能小于开始时间"
    },
    itemsManagement: {
      tableText1: "道具ID",
      tableText2: "道具名称",
      tableText3: "道具展示图片",
      tableText4: "创建时间",
      tableText5: "用户名单",
      tableText6: "新增座驾",
      tableText7: "输入道具名称",
      tableText8: "编辑道具",
      tableText9: "道具特效",
      tableText10: "道具特效地址",
      tableText11: "点击上传道具图标图片",
      tableText12: "点击上传道具特效",
      table2Text1: "用户ID",
      table2Text2: "用户昵称",
      table2Text3: "初始获得时间",
      table2Text4: "失效时间",
      table2Text5: "添加用户",
      table2Text6: "确认删除该用户的道具使用权",
      table2Text7: "时效",
      table2Text8: "请输入时间",
      table2Text9: "国家",
      table2Text10: "最新获得时间"
    },
    adManagement: {
      table1Text1: "新增匹配广告",
      table1Text2: "广告ID",
      table1Text3: "广告标题",
      table1Text4: "广告缩略图",
      table1Text5: "URL",
      table1Text6: "编辑",
      table1Text7: "上架",
      table1Text8: "下架",
      table1Text9: "点击上传广告缩略图",
      table1Text10: "新增广告",
      table1Text11: "编辑广告",
      table1Text12: "确认上架该广告",
      table1Text13: "确认下架该广告",
      table1Text14: "请上传广告缩略图",
      table1Text15: "是否控制版本",
      table1Text16: "财富/SVIP限制",
      table1Text17: "无限制",
      table1Text18: "svip用户且财富等级≥5级",
      table1Text19: "财富等级≥10级"
    },
    groupManagement: {
      table1Text1: "群组id",
      table1Text2: "群组名称",
      table1Text3: "群组头像",
      table1Text4: "群主ID",
      table1Text5: "群主昵称",
      table1Text6: "群组人数",
      table1Text7: "编辑",
      table1Text8: "封禁",
      table1Text9: "已封禁",
      table1Text10: "置顶",
      table1Text11: "取消置顶",
      table1Text12: "请输入群组id",
      table1Text13: "封禁",
      table1Text14: "解除封禁",
      table1Text15: "确认执行封禁操作",
      table1Text16: "确认执行解除封禁操作",
      table1Text17: "确认执行置顶操作",
      table1Text18: "确认执行取消置顶操作",
      table1Text19: "编辑群组",
      table1Text20: "群组介绍",
      table1Text21: "群组公告",
      table1Text22: "点击上传群组头像",
      table1Text23: "隐藏",
      table1Text24: "取消隐藏",
      table1Text25: "确认执行上热门操作",
      table1Text26: "确认执行取消热门操作",
      table1Text27: "详情",
      table1Text28: "标题",
      table1Text29: "内容",
      table1Text30: "修改群组名称",
      table1Text31: "修改群组介绍",
      table1Text32: "修改群组公告",
      table1Text33: "上传修改",
      table1Text34: "确认执行删除群组头像操作",
      table1Text35: "群组靓号",
      table1Text36: "修改群组靓号",
      table1Text37: "该群组没有靓号",
      table1Text38: "确认执行取消隐藏操作",
      table1Text39: "确认执行隐藏操作",
      table1Text40: "确认执行删除群组靓号操作",
      table1Text41: "确认执行删除VIP",
      table1Text42: "群组奖杯",
      table1Text43: "设置群组行政房间",
      table1Text44: "设置行政房间",
      table1Text45: "取消行政房间",
      table1Text46: "是否设置为行政房间",
      table1Text47: "是否取消行政房间",
      table1Text48: "推荐",
      table1Text49: "不推荐",
      table1Text50: "是否推荐房间",
      table1Text51: "是否确定取消推荐",
      table1Text52: "群组背景",
      table1Text53: "确认执行删除群组背景操作",
      table1Text54: "群组经理",
      table1Text55: "群组黑名单",
      table1Text56: "新增群组经理",
      table1Text57: "编辑群组经理",
      table1Text58: "是否确认删除群组：%s的经理: %d",
      table1Text59: "用户ID",
      table1Text60: "用户昵称",
      table1Text61: "用户国家",
      table1Text62: "用户区域",
      table1Text63: "用户角色",
      table1Text64: "用户头像",
      table1Text65: "新增群组黑名单",
      table1Text66: "编辑群组黑名单",
      table1Text67: "是否确认移除群组：%s的黑名单成员: %d"
    },
    // 钻石发放
    diamondIssue: {
      text1: "上传批量发放文件",
      text2: "下载模板",
      text3: "批量发放ID",
      text4: "发放时间",
      text5: "钻石获得者ID",
      text6: "钻石获得者昵称",
      text7: "发放钻石数量",
      text8: "发放类型",
      text9: "发放原因",
      text10: "操作人",
      text11: "上传批量发放文件",
      text12: "未选择文件",
      text13: "已选文件",
      text14: '注意上传文件类型是".xlsx"',
      text15: "确认发放",
      text16: "请选择发放对象",
      text17: "发放状态",
      text18: "未发放",
      text19: "已经发放",
      text20: "游戏币获得者ID",
      text21: "游戏币获得者昵称",
      text22: "发放游戏币数量",
      text23: "活动扶持",
      text24: "活动奖励",
      text25: "获得者区域",
      text26: "获得者ID",
      text27: "获得者昵称",
      text28: "修改SVIP等级",
      text29: "等级有效天数",
      text30: "SVIP过期时间",
      text31: "修改原因",
      text32: "修改状态",
      text33: "SVIP等级",
      text34: "增加积分数",
      text35: "增加后的SVIP积分",
      text36: "增加原因",
      text37: "延长状态",
      text38: "发放单个用户",
      text39: "发放失败",
      text40: "奖励获得者ID",
      text41: "奖励获得者昵称",
      not_xlsx: "此文件非xlsx文件，请上传xlsx文件"
    },
    nobilityIssue: {
      text1: "上传批量发放文件",
      text2: "下载模板",
      text3: "批量发放ID",
      text4: "发放时间",
      text5: "贵族获得者ID",
      text6: "贵族获得者昵称",
      text7: "获得天数",
      text8: "发放类型",
      text9: "发放原因",
      text10: "操作人",
      text11: "上传批量发放文件",
      text12: "未选择文件",
      text13: "已选文件",
      text14: '注意上传文件类型是".xlsx',
      text15: "确认发放",
      text16: "请选择发放对象",
      text17: "获得天数",
      text18: "贵族等级",
      text19: "发放天数",
      text20: "贵族1",
      text21: "贵族2",
      text22: "贵族3",
      text23: "贵族4",
      text24: "贵族5",
      text25: "贵族6",
      not_xlsx: "此文件非xlsx文件，请上传xlsx文件",
      text26: "发放状态",
      text27: "未发放",
      text28: "发放成功",
      text29: "发放失败",
      text30: "贵族7",
      text31: "贵族8",
      text32: "已发放",
      text33: "贵族9",

      p_text1: "道具获得者ID",
      p_text2: "道具获得者昵称",
      p_text3: "道具类型",
      p_text4: "发放道具ID",
      p_text5: "数量",
      p_text6: "有效时间"
    },
    systemInformation: {
      table1Text1: "发布时间",
      table1Text2: "标题",
      table1Text3: "内容",
      table1Text4: "图片",
      table1Text5: "URL",
      table1Text19: "群组ID",
      table1Text20: "用户ID",
      table1Text6: "发布系统消息",
      table1Text7: "系统消息",
      table1Text8: "标题(30字符限制)",
      table1Text9: "消息内容(3000字符限制)",
      table1Text10: "点击上传图片",
      table1Text11: "跳转类型",
      table1Text12: "发送时间",
      table1Text13: "确认执行删除操作",
      table1Text14: "跳转类型",
      table1Text15: "无跳转",
      table1Text16: "网页跳转",
      table1Text17: "跳转到用户",
      table1Text18: "跳转到群组",

      table1Text19: "私聊信息",
      table1Text20: "发送私聊信息",
      table1Text21: "发送人",
      table1Text22: "发送时间",
      table1Text23: "发送内容",
      table1Text24: "成功发送用户数",

      table1Text25: "发送者ID",
      table1Text26: "接收者ID",
      table1Text27: "私聊信息",
      table1Text28: "选择图片",
      table1Text29: "跳转类型",
      table1Text30: "跳转参数",
      table1Text31: "请选择Excel(每份ID数量 < 500个)",
      table1Text32: "发送者ID 默认 100000",
      table1Text33: "请输入消息内容",
      table1Text34: "ID文件上传成功",
      table1Text35: "上传失败,请检查",
      table1Text36: "请输入消息内容",
      table1Text37: "请上传接收者ID文件",
      table1Text38: "保存并创建关联",
      table1Text39: "请选择跳转类型",

      table1Text40: "重新发送",
      table1Text41: "备注",
      table1Text42: "编号ID",
      table1Text43: "定时消息任务",
      table1Text44: "关闭",
      table1Text45: "每7天定时发送",
      table1Text46: "常规系统消息",
      table1Text47: "接收者Svip等级≥",
      table1Text48: "接收者财富等级≥",
      table1Text49: "Svip等级 || 财富等级限制",
      table1Text50: "Svip等级限制≥",
      table1Text51: "财富等级限制≥",
      table1Text52: "限制财富等级可见≥",
      table1Text53: "自动庆祝消息",
      table1Text54: "上传Excel文档",
      table1Text55: "条件用户",
      table1Text56: "接收者累计充值≥",
      table1Text57: "撤回",
      table1Text58: "确认执行撤回操作",
      table1Text59: "已撤回",
      table1Text60: "状态",
      table1Text61: "已发送",
      table1Text62: "撤回中",
      table1Text63: "接收用户区域",
      table1Text64: "定时截止时间",
      table1Text65: "定时状态",
      table1Text66: "已停止",
      table1Text67: "启用中"
    },
    bannerManagement: {
      addCopy: "复制新增",
      table1Text1: "Banner ID",
      table1Text2: "Banner标题",
      table1Text3: "Banner缩略图",
      table1Text4: "URL",
      table1Text5: "群组ID",
      table1Text6: "排序",
      table1Text7: "上架",
      table1Text8: "下架",
      table1Text9: "新增banner",
      table1Text10: "编辑banner",
      table1Text11: "点击上传缩略图",
      table1Text12: "请上传banner缩略图",
      table1Text13: "上架",
      table1Text14: "下架",
      table1Text15: "确认执行下架操作",
      table1Text16: "确认执行上架操作",
      table1Text17: "跳转类型",
      table1Text18: "群组",
      table1Text19: "上架时间",
      table1Text20: "下架时间",
      table1Text21: "上架时间编辑",
      table1Text22: "礼物栏Banner"
    },
    openManagement: {
      table1Text1: "闪屏 ID",
      table1Text2: "闪屏标题",
      table1Text3: "闪屏缩略图",
      table1Text4: "URL",
      table1Text5: "群组ID",
      table1Text6: "排序",
      table1Text7: "上架",
      table1Text8: "下架",
      table1Text9: "新增闪屏",
      table1Text10: "编辑闪屏",
      table1Text11: "点击上传缩略图",
      table1Text12: "请上传闪屏缩略图",
      table1Text13: "上架",
      table1Text14: "下架",
      table1Text15: "确认执行下架操作",
      table1Text16: "确认执行上架操作",
      table1Text17: "跳转类型",
      table1Text18: "群组",
      table1Text19: "上架时间",
      table1Text20: "下架时间",
      table1Text21: "上架时间编辑",
      table1Text22: "类型",
      table1Text23: "普通",
      table1Text24: "周CP",
      table1Text25: "周星"
    },
    popupManagement: {
      table1Text1: "运营弹窗 ID",
      table1Text2: "运营弹窗标题",
      table1Text3: "运营弹窗缩略图",
      table1Text4: "URL",
      table1Text5: "群组ID",
      table1Text6: "排序",
      table1Text7: "上架",
      table1Text8: "下架",
      table1Text9: "新增运营弹窗",
      table1Text10: "编辑运营弹窗",
      table1Text11: "点击上传缩略图",
      table1Text12: "请上传运营弹窗缩略图",
      table1Text13: "上架",
      table1Text14: "下架",
      table1Text15: "确认执行下架操作",
      table1Text16: "确认执行上架操作",
      table1Text17: "跳转类型",
      table1Text18: "群组",
      table1Text19: "上架时间",
      table1Text20: "下架时间",
      table1Text21: "上架时间编辑"
    },
    page401: {
      content: "Oh~~您没有浏览这个页面的权限~"
    },
    page404: {
      content: "Oh~~您的页面好像飞走了~"
    },
    page500: {
      content: "Oh~~鬼知道服务器经历了什么~"
    },
    backBtnGroup: {
      backHome: "返回首页",
      backLast: "返回上一页"
    },
    login: {
      title: "hilo后台管理系统"
    },
    // 表情管理
    emoji: {
      text1: "表情ID",
      text2: "表情名称",
      text3: "表情图",
      text4: "架上排序",
      text5: "请输入表情名称",
      text6: "确认下架该表情",
      text7: "确认上架该表情",
      text8: "表情特效",
      text9: "上传表情图标",
      text10: "上传表情特效",
      text11: "新增表情",
      text12: "编辑表情",
      text13: "",
      text14: "",
      text15: ""
    },
    theme: {
      text1: "主题ID",
      text2: "主题名称",
      text3: "主题图",
      text4: "架上排序",
      text5: "请输入主题名称",
      text6: "确认下架该主题",
      text7: "确认上架该主题",
      text8: "表情特效",
      text9: "上传主题图",
      text10: "上传表情特效",
      text11: "新增主题",
      text12: "编辑主题",
      text13: "请上传主题图",
      text14: "",
      text15: ""
    },
    // 头饰
    tire: {
      text1: "头饰ID",
      text2: "头饰名称",
      text3: "头饰展示图片",
      text4: "头饰特效",
      text5: "新增头饰",
      text6: "点击上传头饰展示图片",
      text7: "点击上传头饰特效",
      text8: "确认删除该用户的头饰使用权",
      text9: "编辑头饰",
      text10: "请上传头饰展示图片",
      text11: "请上传头饰特效",
      text12: "价格",
      text13: "有效时间（天）",
      text14: "",
      text15: "",
      text16: "",
      text17: ""
    },
    // 勋章
    order: {
      text1: "勋章ID",
      text2: "勋章名称",
      text3: "勋章展示图片",
      text4: "勋章特效",
      text5: "新增勋章",
      text6: "点击上传勋章展示图片",
      text7: "点击上传勋章特效",
      text8: "确认删除该用户的勋章使用权",
      text9: "编辑勋章",
      text10: "请上传勋章展示图片",
      text11: "架上排序",
      text12: "勋章类型",
      text13: "个人勋章",
      text14: "房间勋章",
      text15: "铭牌展示图片",
      text16: "点击上传铭牌展示图片",
      text17: "点击上传ID装饰展示图片",
      text18: "确认删除该用户的ID装饰框使用权"
    },
    onlineStatistics: {
      text1: "公会用户",
      text2: "普通用户",
      text3: "",
      text4: "",
      text5: "",
      text6: ""
    },
    // 玩法管理--幸运盒子
    playLabel: {
      tab1: "奖品设置",
      tab2: "抽奖统计",
      tab3: "抽奖明细",
      tab4: "高级奖品设置",
      tab5: "高级抽奖统计",
      tab6: "高级抽奖明细",
      agencyOperate: "操作",
      newPrize: "新增奖品",
      search: "搜索",
      editPrize: "奖品编辑",
      addPrize: "新增奖品",
      use: "确认上架该奖品？",
      useNo: "确认下架该奖品？",
      play_prize_list: {
        isUp: "上架",
        unUp: "下架",
        iss: "是",
        noo: "否",
        diamond: "钻石",

        prizeID: "奖品ID",
        prizeName: "奖品名称",
        worth: "价值",
        currentImIg: "当前数量",
        averageDailySum: "日均临界数量",
        prizeProbability: "奖品概率",
        status: "状态",
        screenPush: "是/否公屏推送",
        scrollPush: "是/否滚动推送",
        prizeFu: "是/否为大奖",
        prizeFuSum1: "用户抽中奖品后",
        prizeFuSum2: "大于0的整数",
        prizeFuSum3: "次，该奖品的中奖概率为0",
        worth1: "奖品(数量/单价)",
        showImg: "展示图片",
        showBtn: "上传",
        statusFu: "是否上架",
        durationName: "奖品时长",
        diamondValueName: "奖品价值",
        giftIid: "礼物id",
        awardValue: "奖品价值"
      },
      play_draw_list: {
        drawDate: "日期",
        personNumber: "总抽奖人数",
        everyNumber: "总抽奖次数",
        goldNumber: "消耗总金币",
        prizeNumber: "抽出奖品总价值",
        recycleDiamond: "回收钻石总额",
        recycle: "回收率"
      },
      play_draw_detail_list: {
        prizeID: "奖品ID",
        drawDate: "日期",
        prizeName: "奖品名称",
        worth: "价值",
        winningNumber: "中奖次数",
        winningWorth: "中奖价值"
      }
    },
    // 玩法管理--水果机
    fruits: {
      tabText1: "每日统计",
      tabText2: "轮次明细",
      tabText3: "用户明细",
      tabText4: "投注榜",
      tabText5: "中奖榜",
      tabText6: "用户",
      tabText7: "北京时间",
      tabText8: "沙特时间",
      tabText9: "脚本管理",
      tabText10: "利润率(亏损)",
      tabText11: "利润率(盈利)",
      tabText12: "高级用户明细",
      tab: {
        text1: "日期",
        text2: "参与人数",
        text3: "中奖人数",
        text4: "投注钻石数",
        text5: "中奖钻石数",
        text6: "系统回收",
        text7: "今日盈余",
        text8: "奖池盈余",
        text9: "回收率",
        text10: "日期",
        text11: "轮数",
        text12: "参与人数",
        text13: "中奖人数",
        text14: "投注钻石数",
        text15: "中奖钻石数",
        text16: "系统回收",
        text17: "本轮盈余",
        text18: "奖池盈余",

        text20: "ID: ",
        text21: "消费钻石: ",
        text22: "中奖钻石: ",

        text30: "排名",
        text31: "用户ID",
        text32: "国家",
        text33: "投注钻石数",
        text34: "中奖钻石数",
        text35: "盈亏（中奖-投注）",
        text36: "时段内充值 $", //充值金额-钻石 $
        text37: "投注金币数",
        text38: "中奖金币数",
        text39: "充值金额-金币 $",
        text40: "钻石兑换金币数",

        text41: "留存率",
        text42: "充值人数",
        text43: "奖池回收",
        text44: "系统回收",
        text45: "利润率",
        text46: "历史最高单笔 $",
        text47: "创建脚本",
        text48: "删除脚本",
        text49: "等待执行",
        text50: "已执行",
        text51: "是否确认删除事件ID：",
        text52: "的脚本",
        text53: "SVIP等级",
        text54: "小奖奖池盈余",
        text55: "小奖奖池回收",
        text56: "大奖奖池盈余", //BigPool
        toLab1: "事件ID",
        toLab2: "事件类型",
        toLab3: "用户ID",
        toLab4: "开始时间",
        toLab5: "触发轮次数",
        toLab6: "操作时间",
        toLab7: "操作人",

        toLab8: "是否生效",
        toLab9: "生效时间",
        toLab10: "生效轮次",
        toLab11: "用户本轮盈亏",
        toLab12: "平台本轮盈亏",
        toLab13: "开奖位置",
        toLab14: "必中",
        toLab15: "必不中"
      }
    },
    // 活动管理--群组对战
    groupFight: {
      fightTime: "活动时间",
      grouping: "分组",
      reward_yes_ar_no: "奖励发放",
      no_reward: "未发奖",
      yes_reward: "已发奖",
      fightDetail: {
        groupId: "请输入群组ID",
        groupSeek: "搜索",
        uploading: "上传群组对战",
        confirming: "确定",
        oneKey: "奖励一键发放",
        newGroupPK: "新建群组对战",
        groupImg1: "群组头像1",
        groupImg2: "群组头像2",
        groupID1: "群组ID1",
        groupID2: "群组ID2",
        groupWater1: "群组流水1",
        groupWater2: "群组流水2",
        grantSuccess: "发放成功",
        grantDoubt1: "是否确定发放本轮群组对决奖励",
        grantDoubt2: "本轮活动尚未结束!",
        pkStatus: "你确认下架该PK群组?",
        pkStatus1: "你确认上架该PK群组?",
        grantSuccess2: "PK群组上传成功",
        delPk: "删除",
        delPk1: "你确认删除该PK群组?",
        groupAdd: "新增PK群组",
        groupEdit: "编辑PK群组",
        code1: "群组1",
        code2: "群组2",
        codeTex: "请输入群组ID"
      }
    },
    // 水果大亨
    fruitsBigwig: {
      fightTime: "活动时间",
      sumJackpot: "总奖池",
      listJackpot: "榜单奖池瓜分数额",
      watermelonJackpot: "西瓜奖池瓜分数额",
      diamond: "钻石"
    },
    // 活动配置
    activityDeploy: {
      s_search1: "活动ID",
      s_search2: "活动名称",
      s_search3: "查询",
      s_search4: "创建",
      s_search6: "任务ID",
      s_search7: "任务名称",
      s_search8: "普通冲榜",
      s_search9: "充值奖励",
      s_search10: "创建活动",
      s_search11: "编辑活动",
      s_search12: "礼物配置",
      s_search13: "配置成功",
      s_search14: "请输入",
      s_search15: "礼物1",
      s_search16: "礼物2",
      s_search17: "礼物3",
      s_search18: "礼物4",
      s_search19: "请按顺序输入,最少3个",
      s_search20: "是否确认删除活动：",
      s_search21: "活动链接",
      s_search22: "国家管理员选举",
      s_search23: "群PK",
      s_search24: "道具升级",
      s_search25: "记录充值",
      s_search26: "CP活动",
      s_search27: "统计区域(旧)",
      s_search28: "全部",
      s_search29: "阿语区",
      s_search30: "其他区域",
      s_search31: "国家榜单",
      s_search32: "指定国家",
      s_search33: "关联ID",
      s_search34: "禁止代理上榜",
      s_search35: "送礼人SVIP",
      s_search36: "展示在礼物面板",
      s_search37: "国管活动",
      s_search38: "队伍数量/人数",
      s_search39: "充值门槛",
      s_search40: "收礼人SVIP",
      s_search41: "收礼人性别",
      s_search42: "送礼人性别",
      s_search43: "统计方式",
      s_search44: "禁止推广员上榜",
      s_search45: "否",
      s_search46: "互送CP",
      s_search47: "一对一CP",
      s_search48: "黄钻充值",
      s_search49: "金币充值",
      s_search50: "全部充值",
      s_search51: "贵族活动",
      s_search52: "现金赛",
      s_search53: "赛程",
      s_search54: "数据关联",
      s_search55: "现金赛-支持者",
      s_search56: "收票人性别",
      s_search57: "活动循环",
      s_search58: "循环间隔(秒/天)",
      s_search59: "现金赛-海选",
      s_search60: "群PK 1V1",
      s_search61: "英语区",
      s_search62: "土语区",
      s_search63: "票数",
      s_search64: "充值数据",
      s_search65: "老用户礼包$50",
      s_search66: "老用户礼包$10||$100",
      s_search67: "SVIP礼包",
      s_search68: "上麦礼包",
      s_search69: "活动主题",
      s_search70: "道具ID",
      s_search71: "主题等级(≥)",
      s_search72: "魅力等级(≥)",
      s_search73: "充值要求(≥)",
      s_search74: "上麦时长(s)",
      s_search75: "补票类型",
      s_search76: "运营侧活动",
      s_search77: "游戏补偿活动",
      s_search78: "充值要求(=)",
      s_search79: "SVIP冲榜活动",
      s_search80: "转盘配置ID",
      s_search81: "SVIP",
      s_search82: "统计区域",
      s_search83: "多选区域",
      s_search84: "历史累充福利活动",
      s_search85: "国家冲榜",
      s_search86: "巅峰俱乐部",
      s_search87: "组队充值活动",
      s_search88: "戒指类活动",

      act_table1: "活动ID",
      act_table2: "Banner",
      act_table3: "活动名称",
      act_table4: "活动类型",
      act_table5: "开始时间",
      act_table6: "结束时间",
      act_table7: "其他",
      act_table8: "操作",
      act_table9: "任务配置",
      act_table10: "活动礼物",
      act_table11: "编辑",
      act_table12: "名单下载",
      act_table13: "删除",
      act_table14: "奖励",
      act_table15: "复制",
      act_table16: "投票活动",
      act_table17: "充值统计",
      act_table18: "缩略图",
      act_table19: "活动状态",
      act_table20: "活动备注",
      act_table21: "选手名单",
      act_table22: "待上线",
      act_table23: "在线中",
      act_table24: "已结束",

      act_table25: "128 进 32",
      act_table26: "32 进 16",
      act_table27: "16 进 8",
      act_table28: "8 进 4",
      act_table29: "4 进 2",
      act_table30: "2 进 1",

      act_table31: "新增补票",
      act_table32: "编号ID",
      act_table33: "banner预览图",
      act_table34: "补票时间",
      act_table35: "用户ID",
      act_table36: "补票数量",
      act_table37: "操作人",
      act_table38: "check",
      act_table39: "补票成功",
      act_table40: "国管国家",
      act_table41: "送礼得票比例",
      act_table42: "充值得票比例",
      act_table43: "收票限制",
      act_table44: "充值点数",
      act_table45: "新增数据",
      act_table46: "循环中",

      act_table47: "是否家族活动",
      act_table48: "是否有日榜",
      act_table49: "送礼勋章升级",
      act_table50: "收礼勋章升级",
      act_table51: "记录累充门槛",

      exp_Md0: "数据导出",
      exp_Md1: "2进1",
      exp_Md2: "4进2",
      exp_Md3: "8进4",
      exp_Md4: "16进8",
      exp_Md5: "32进16",
      exp_Md6: "活动ID",
      exp_Md7: "排行数量",
      exp_title01: "排名",
      exp_title02: "ID",
      exp_title03: "区域",
      exp_title04: "国家",
      exp_title05: "CpID",
      exp_title06: "用户靓号",
      exp_title07: "收礼数量",
      exp_user_title0: "点此上传128名单",
      exp_user_title01: "uid",
      exp_user_title02: "性别",
      exp_user_title03: "用户ID",
      exp_user_title04: "国家",
      exp_user_title05: "区域",
      exp_user_title06: "最近30天充值(美元)",
      exp_user_title07: "累积充值(美元)",
      exp_user_title08: "SVIP等级"
    },
    taskDeploy: {
      act_table1: "任务ID",
      act_table2: "任务名称",
      act_table3: "所属活动",
      act_table4: "任务类型",
      act_table5: "任务触发数值",
      act_table6: "个人送礼梯度奖",
      act_table7: "个人送礼排行",
      act_table8: "个人收礼排行",
      act_table9: "房间送礼排行",
      // act_table10: "1级",
      // act_table11: "2级",
      // act_table12: "3级",
      // act_table13: "4级",
      // act_table14: "5级",
      // act_table20: "6级",
      // act_table21: "7级",
      // act_table22: "8级",
      // act_table23: "9级",
      // act_table24: "10级",
      act_table15: "等级",
      act_table16: "添加成功",
      act_table17: "是否确认删除任务：",
      act_table18: "任务配置奖励列表",
      act_table19: "配置奖励",
      act_table25: "个人充值梯度",
      // act_table26: "11级",
      act_table27: "每张选票获得类型",
      act_table28: "每张选票触发数值",
      act_table29: "选票获得次数",
      act_table30: "个人收到选票排行",
      act_table31: "个人送出选票排行",
      act_table32: "送礼",
      act_table33: "收礼",
      act_table34: "个人收礼梯度奖",
      // act_table35: "个人充值梯度奖",
      act_table36: "道具升级（送礼）",
      act_table37: "CP送礼榜单",
      act_table38: "奖池瓜分-竞选队长",
      act_table39: "奖池数值",
      act_table40: "瓜分人数",
      act_table41: "关联类型",
      act_table42: "个人充值排行",
      act_table43: "svip限制等级",
      act_table44: "个人送礼排行（日榜）",
      act_table45: "第几天",
      act_table46: "个人送礼梯度-队伍",
      act_table47: "送礼排行-队伍",
      act_table48: "队伍编号",
      act_table49: "队长来源活动",
      act_table50: "队长来源活动任务类型",
      act_table51: "循环周期（天）",
      act_table52: "家族送礼排行",
      act_table53: "家族送礼排行-支持者",
      act_table54: "道具升级（收礼）",
      act_table55: "游戏充值和下注梯度",

      act_table56: "游戏",
      act_table57: "充值门槛",
      act_table58: "水果机",
      act_table59: "下注门槛",

      act_table60: "家族收礼排行-家族长",
      act_table61: "家族收礼排行-支持者",
      act_table62: "埃及slot",
      act_table63: " h5游戏-slot",
      act_table64: "群pk勋章升级",
      act_table65: "个人收礼排行-男",
      act_table66: "个人收礼排行-女",
      act_table67: "赛车",
      act_table68: "灵魂伴侣送礼榜单",
      act_table69: "闺蜜送礼榜单",
      act_table70: "兄弟送礼榜单",
      act_table71: "现金队伍奖励",
      act_table72: "个人收礼排行（日榜）",
      act_table73: "CP-收票榜单",
      act_table74: "CP-现金队伍奖励",
      act_table75: "群1v1PK勋章升级",
      act_table76: "1v1PK星星榜单",
      act_table77: "群PK房间星星榜单",
      act_table78: "个人充值梯度-每日",
      act_table79: "个人充值任务-单笔",
      // act_table80: "个人充值任务-每日最高等级",
      act_table81: "收礼排行-队伍",
      act_table82: "累计充值奖励-属性等级",
      act_table83: "关联等级",
      act_table84: "游戏等级",
      act_table85: "svip等级",
      act_table86: "财富等级",
      act_table87: "充值数值-美分",
      act_table88: "游戏充值最高补偿",
      act_table89: "活动包含游戏id",
      act_table90: "上麦礼包奖励-属性等级",
      act_table91: "SVIP上麦",
      act_table92: "CP 等级",
      act_table93: "个人送礼排行(SVIP)",
      act_table94: "个人送礼梯度(SVIP)",
      act_table95: "转盘抽奖价值排行",
      act_table96: "转盘抽奖次数梯度奖",
      act_table97: "家族充值梯度奖-支持者",
      act_table98: "家族充值排行",
      act_table99: "排名开始",
      act_table100: "排名截止",
      act_table101: "个人历史累充奖励-最高",
      act_table102: "累充开始",
      act_table103: "累充截止",
      act_table104: "单笔充值-美分",
      act_table105: "家族充值任务-最高-家族长",
      act_table106: "家族充值任务-最高-支持者",
      act_table107: "国家收礼梯度",
      act_table108: "国家收礼排行-支持者",
      act_table109: "个人收礼排行-国家",
      act_table110: "家族收礼任务梯度奖",
      act_table111: "家族送礼任务梯度奖",
      act_table112: "CP互送礼&充值梯度任务",
      act_table113: "CP充值榜单",
      act_table114: "个人历史累充梯度奖",
      act_table115: "房间送礼任务梯度奖",
      act_table116: "队伍充值奖励-支持者-最高",
      act_table117: "队伍充值榜单-支持者",
      act_table118: "个人上麦&收礼梯度奖",
      act_table119: "上麦要求(s)",
      act_table120: "单礼物送礼排行-支持者",
      act_table121: "房间收礼排行-每日",

      level1: "1级",
      level2: "2级",
      level3: "3级",
      level4: "4级",
      level5: "5级",
      level6: "6级",
      level7: "7级",
      level8: "8级",
      level9: "9级",
      level10: "10级",
      level11: "11级",
      level12: "12级",
      level13: "13级",
      level14: "14级",
      level15: "15级",
      level16: "16级",
      level17: "17级",
      level18: "18级",
      level19: "19级",
      level20: "20级",
      level21: "21级",
      level22: "22级",
      level23: "23级",
      level24: "24级",
      level25: "25级",
      level26: "26级",
      level27: "27级",
      level28: "28级",
      level29: "29级",
      level30: "30级",
      level31: "31级",
      level32: "32级",
      level33: "33级",
      level34: "34级",
      level35: "35级",
      level36: "36级",
      level37: "37级",
      level38: "38级",
      level39: "39级",
      level40: "40级",
      level41: "41级",
      level42: "42级",
      level43: "43级",
      level44: "44级",
      level45: "45级",
      level46: "46级",
      level47: "47级",
      level48: "48级",
      level49: "49级",
      level50: "50级",
      level51: "51级",
      level52: "52级",
      level53: "53级",
      level54: "54级",
      level55: "55级",
      level56: "56级",
      level57: "57级",
      level58: "58级",
      level59: "59级",
      level60: "60级",
      level61: "61级",
      level62: "62级",
      level63: "63级",
      level64: "64级",
      level65: "65级",
      level66: "66级",
      level67: "67级",
      level68: "68级",
      level69: "69级",
      level70: "70级",
      level71: "71级",
      level72: "72级",
      level73: "73级",
      level74: "74级",
      level75: "75级",
      level76: "76级",
      level77: "77级",
      level78: "78级",
      level79: "79级",
      level80: "80级",

      award_table1: "ID",
      award_table2: "奖品",
      award_table3: "期限/天",
      award_table4: "数量",
      award_table5: "创建时间",
      award_table6: "钻石",
      award_table7: "贵族",
      award_table8: "头饰",
      award_table9: "座驾",
      award_table10: "勋章",
      award_table11: "是否确认删除奖励：",
      award_table12: "道具类型",
      award_table13: "道具ID",
      award_table14: "期限",
      award_table15: "单位",
      award_table16: "数量",
      award_table17: "铭牌",
      award_table18: "盲盒券",
      award_table19: "礼物",
      award_table20: "金币",
      award_table21: "特殊奖励（仅图片展示）",
      award_table22: "特殊名称",
      award_table23: "特殊价值",
      award_table24: "特殊图片",
      award_table25: "选票",
      award_table26: "ID装饰框",
      award_table27: "SVIP积分",
      award_table28: "转盘抽奖券",
      award_table29: "房间头像框",
      award_table30: "个人资料页挂饰",
      award_table31: "进场尾灯",
      award_table32: "房间气泡框",
      award_table33: "麦位光波",
      award_table34: "个人资料页弹窗装饰"
    },
    playerRoll: {
      title01: "上传名单",
      title02: "模板下载",
      title03: "确认上传",
      title04: "点击上传",
      title05: "名单编辑",
      title06: "修改成功",
      title07: "",
      title08: "",
      title09: "",
      title10: "",

      list01: "赛程",
      list02: "队伍ID",
      list03: "用户1ID",
      list04: "昵称1",
      list05: "用户2ID",
      list06: "昵称2",
      list07: "用户3ID",
      list08: "昵称3",
      list09: "用户4ID",
      list10: "昵称4",
      list11: "国籍1",
      list12: "国籍2",

      list13: "用户ID",
      list14: "用户昵称",
      list15: "用户国籍",
      list16: "累积充值",
      list17: "所在区域",
      list18: "本赛程票数",
      list19: "最近30天充值",
      list20: "SVIP等级",
      list21: "国籍3",
      list22: "国籍4"
    },
    turntableDeploy: {
      tu_table1: "转盘ID",
      tu_table2: "转盘名称",
      tu_table3: "新增转盘",
      tu_table4: "编辑",
      tu_table5: "备注",
      tu_table6: "详情配置",
      tu_table7: "转盘配置",
      tu_table8: "1抽花费",
      tu_table9: "每充值(美分)",
      tu_table10: "奖品配置",
      tu_table11: "抽奖统计",
      tu_table12: "奖励明细",
      tu_table13: "新增奖品",
      tu_table14: "奖品图片",
      tu_table15: "1抽花费N劵",
      tu_table16: "充值(美分)得N劵",
      tu_table17: "是否确认删除：",
      tu_table18: "是否确认删除该奖品？",
      tu_table19: "抽奖次数",
      tu_table20: "每日免费抽",
      tu_list_tab1: "奖品ID",
      tu_list_tab2: "奖品名称",
      tu_list_tab3: "道具ID",
      tu_list_tab4: "期限/天数",
      tu_list_tab5: "数量",
      tu_list_tab6: "奖品价值",
      tu_list_tab7: "奖品剩余数",
      tu_list_tab8: "每日奖品数",
      tu_list_tab9: "奖品概率",
      tu_list_tab10: "状态",
      tu_list_tab11: "日期",
      tu_list_tab12: "奖品类型",
      tu_list_tab13: "总抽奖人数",
      tu_list_tab14: "总抽奖次数",
      tu_list_tab15: "抽出奖品总价值",
      tu_list_tab16: "用户ID",
      tu_list_tab17: "奖品ID",
      tu_list_tab18: "奖品类型",
      tu_list_tab19: "中奖价值",
      tu_list_tab20: "中奖次数",
      tu_list_tab21: "是否上架",
      tu_list_tab22: "每送礼(钻石)",
      tu_list_tab23: "送礼(钻石)得N劵"
    },
    // 批量IP查询
    selectIP: {
      uploadFile: "上传批量查询文件",
      uploadFile1: "上传apk文件",
      text12: "未选择文件",
      text13: "已选文件",
      text14: '注意上传文件类型是".xlsx"',
      text15: '注意上传文件类型是".apk"',
      not_xlsx: "此文件非xlsx文件，请上传xlsx文件",
      dow: "下载批量查询结果"
    },
    listWeekStar: {
      issueGift: "发布礼物",
      updateGift: "编辑礼物",
      activityTime: "活动时间",
      weekGift: "周星礼物",
      agencyOperate: "操作",
      reminder: "请输入礼物ID",

      weekGift1: "礼物1",
      weekGift2: "礼物2",
      weekGift3: "礼物3",

      time1: "2022-03-01 ~ 2022-03-07",
      time2: "2022-03-08 ~ 2022-03-14",
      time3: "2022-03-15 ~ 2022-03-21",
      time4: "2022-03-22 ~ 2022-03-28",
      time5: "2022-03-29 ~ 2022-04-04"
    },
    expandManagement: {
      tab_lab_title1: "邀请数据",
      tab_lab_title2: "推广团队管理",
      tab_lab_title3: "新增团队",
      tab_lab_title4: "编辑",
      tab_lab_title5: "导出",
      tab_lab_title6: "绑定",
      tab_lab_title7: "解绑",
      tab_lab_title8: "邀请人ID",
      tab_lab_title9: "被邀请ID",
      tab_lab_title10: "平台",
      tab_lab_title11: "是否确认解绑该关系",
      tab_lab_title12: "绑定新用户",
      tab_lab_title13: "批量邀请-导入成功",
      tab_lab_title14: "欢迎派对审核",
      tab_lab_title15: "HiloID",
      tab_lab_title16: "经理ID",
      tab_lab_title17: "解散",
      tab_lab_title18: "是否确认解散",
      tab_lab_title19: "经理&推广员ID",
      tab_lab_title20: "修改经理ID",
      tab_lab_title21: "新的经理ID",
      tab_lab_title22: "邀请审核（阿语区）",
      tab_lab_title23: "团队统计",
      tab_lab_title24: "推广员统计",
      tab_lab_title25: "编辑团队",
      tab_lab_title26: "编辑推广员",
      tab_lab_title27: "是否确认删除该推广员",
      tab_lab_title28: "新增推广员",
      tab_lab_title29: "请输入推广员ID",
      tab_lab_title30: "新增",
      tab_lab_title31: "一键移除无效推广团队",
      tab_lab_title32: "30天内充值为0的团队(仅限30天前创建的团队)",
      tab_lab_title33: "30天内邀请充值为0的推广员(仅针对30天前加入)",
      tab_lab_title34: "移除无效推广团队或推广员",

      tab_list_title1: "团队名称",
      tab_list_title2: "经理ID",
      tab_list_title3: "推广员个数",
      tab_list_title4: "邀请总人数",
      tab_list_title5: "邀请充值用户数",
      tab_list_title6: "30天内充值$",
      tab_list_title7: "60天内充值$",
      tab_list_title8: "推广员ID",
      tab_list_title9: "30天内代理充值$",
      tab_list_title10: "绑定时间",
      tab_list_title11: "代理ID",
      tab_list_title12: "区间充值总额",
      tab_list_title13: "推广员昵称",
      tab_list_title14: "区间邀请总人数",
      tab_list_title15: "区间邀请充值用户数",

      tab_list_invitation1: "推广员ID",
      tab_list_invitation2: "团队名称",
      tab_list_invitation3: "被邀请人ID",
      tab_list_invitation4: "来自平台",
      tab_list_invitation5: "其他平台ID",
      tab_list_invitation6: "邀请原因",
      tab_list_invitation7: "群组ID",
      tab_list_invitation8: "群组人数",
      tab_list_invitation9: "群组奖杯",
      tab_list_invitation10: "邀请日期",
      tab_list_invitation11: "30天内充值$",
      tab_list_invitation12: "60天内充值$",
      tab_list_invitation13: "绑定日期",
      tab_list_invitation14: "30天内代理充值$",
      tab_list_invitation15: "召回后30天内代理充值$",
      tab_list_invitation16: "召回后充值金额",
      tab_list_invitation17: "注册时间",
      tab_list_invitation18: "推广员昵称",

      edit_team_title1: "推广员ID",
      edit_team_title2: "推广员昵称",
      edit_team_title3: "国家",
      edit_team_title4: "SVIP等级",
      edit_team_title5: "注册时间",
      edit_team_title6: "最后登录时间",
      edit_team_title7: "区间邀请总人数",
      edit_team_title8: "区间邀请充值用户数",
      edit_team_title9: "区间充值总额",

      table_list01: "头像",
      table_list02: "ID",
      table_list03: "国家",
      table_list04: "来自平台",
      table_list05: "其他平台ID",
      table_list06: "其它平台充值金额",
      table_list07: "是否已邀请",
      table_list08: "充值金额",
      table_list09: "注册时间",
      table_list10: "同IP账号数",
      table_list11: "同设备账号数",
      table_list12: "申请时间",
      table_list13: "邀请人ID",
      table_list14: "视频",
      table_list15: "操作",
      table_list16: "查看视频",
      table_list17: "审核",
      table_list18: "再次审核",
      table_list19: "是否通过申请",
      table_list20: "欢迎派对等级",
      table_list21: "选择拒绝原因",
      table_list22: "通过",
      table_list23: "拒绝",
      table_list24: "同一IP或同一设备已有其它账号获得奖励",
      table_list25: "填写的APP名称或ID或SVIP等级与视频不符",
      table_list26: "已申请过奖励",
      table_list27: "视频不合格，无法确认真实性或不能证明两个账号同属一个人",
      table_list28: "通过,下一条",
      table_list28_bottom: "完成，下一条",
      table_list29: "欢迎派对审核",
      table_list30: "派对审核",
      table_list31: "已通过",
      table_list32: "已拒绝",
      table_list33: "等级",
      table_list34: "审核时间",
      table_list35: "审核人",
      table_list36: "同设备通过数",
      table_list37: "同ip通过数",
      table_list38: "ip关联账号数",
      table_list39: "设备关联账号数",
      table_list40: "通过",
      table_list41: "拒绝",
      table_list42: "邀请等级",
      table_list43: "审核结果",
      table_list44: "数据查询中心",
      table_list45: "新用户没有充值，请先充值$50",
      table_list46: "是否绑定号码",
      table_list47: "同号码绑定账户",
      table_list48: "没有绑定手机号码",
      table_list49: "充值奖励发放",
      table_list50: "待发放",
      table_list51: "充值奖励等级",
      table_list52: "被邀请数量",
      table_list53: "邀请属性",
      table_list54: "拉新",
      table_list55: "召回",
      table_list56: "召回日期",
      table_list57: "奖励发放时间",
      table_list58: "奖励审核人",
      table_list59: "未发放",
      table_list60: "已发放",
      table_list61: "充值奖励",
      table_list62: "老用户需要充值$50",
      table_list63: "第三次邀请",
      table_list64: "是否发放充值奖励",
      table_list65: "不发放充值奖励",
      table_list66: "同时发放充值奖励",
      table_list67: "第四次邀请",
      table_list68: "第五次邀请",
      table_list69: "拒绝,下一条",
      table_list70: "第六次邀请",
      table_list71: "第七次邀请",
      table_list72: "第八次邀请",
      table_list73: "第九次邀请",
      table_list74: "第十次邀请",
      modal_lab1: "请填写完整",
      modal_lab2: "推送欢迎派对消息",
      modal_lab3: "取消推送",
      modal_lab4: "是否确定修改经理ID",

      pass_re1: "日期",
      pass_re2: "已通过",
      pass_re3: "已拒绝",
      pass_re4: "阿语区已通过",
      pass_re5: "阿语区已拒绝",
      pass_re6: "英语区已通过",
      pass_re7: "英语区已拒绝",
      pass_re8: "土语区已通过",
      pass_re9: "土语区已拒绝",
      pass_re10: "审核人员",
      pass_re11: "审核数量"
    },
    reportManagement: {
      postReport: "post举报",
      commentReport: "评论举报",
      fuseList: "评论熔断列表",
      postFuseList: "post熔断列表",
      pleaseChoose: "请选择语言区",
      pleaseUserId: "请输入用户ID",
      languageArea: "语言区",
      languageAr: "阿拉伯语区",
      languageEn: "英语区",
      languageY: "印尼语区",
      languageTr: "土耳其语区",
      userId: "用户ID",
      username: "用户名称",
      topicName: "话题名称",
      postContent: "内容",
      commentContent: "评论内容",
      image: "图片",
      audio: "音频",
      reportTime: "最早举报时间",
      reportNum: "举报次数",
      reporterId: "举报人id",
      status: "状态",
      operater: "操作人员",
      // ignore: '忽略',
      ignore: "检查通过",
      shield: "屏蔽",
      // ignored: '已忽略',
      ignored: "已检查通过",
      shielded: "已屏蔽",
      cancelShield: "取消屏蔽",
      deleted: "已删除",
      mute: "禁言",
      muted: "已禁言",
      unMute: "解除禁言 禁言到期时间: {date}",
      operatRole: "操作人角色",
      role1: "审核人员",
      role2: "超管",
      role3: "后台管理员",
      role4: "国家管理员",
      showBigImg: "查看大图",
      operatTime: "操作时间",
      checkCancelShield: "确认执行取消屏蔽操作",

      deleteAndBan: "删除并禁言",
      deleteAndBanId: "删除并封禁ID",
      batchDelete: "批量删除",
      batchIgnore: "批量忽略",
      delete: "删除",
      pleaseChooseContent: "请选择内容",
      sureAction: "确认对所选项目进行 {action}吗"
    },
    certificationAudit: {
      filtrateTab1: "ID",
      filtrateTab2: "国家",
      filtrateTab3: "区域",
      filtrateTab4: "请输入...",
      filtrateTab5: "待审核",
      filtrateTab6: "已审核",
      filtrateTab7: "操作",
      filtrateTab8: "审核",
      filtrateTab9: "查询",
      filtrateTab10: "审核通过",
      filtrateTab11: "已拒绝",
      tab1: "头像",
      tab2: "ID",
      tab3: "昵称",
      tab4: "国家",
      tab5: "充值金额",
      tab6: "注册时间",
      tab7: "是否绑定号码",
      tab8: "同号码绑定账户",
      tab9: "同IP账户",
      tab10: "同设备账户通过数",
      tab11: "同IP通过数",
      tab12: "申请时间",
      tab13: "审核状态",
      tab14: "审核人",
      tab15: "审核时间"
    },
    administratorOperationRecord: {
      tab_lab_title1: "模块",
      tab_lab_title2: "处理ID",
      tab_lab_title3: "操作人ID",
      tab_lab_title4: "日期",
      tab_lab_title5: "操作内容",
      tab_lab_title6: "描述",
      tab_lab_title7: "图片/视频",
      tab_lab_title8: "请输入处理ID",
      tab_lab_title9: "请输入操作人ID",
      tab_lab_title10: "处理ID区域"
    },
    setting: {
      tab_lab_title1: "当前版本",
      tab_lab_title2: "平台",
      tab_lab_title3: "状态",
      tab_lab_title4: "生效",
      tab_lab_title5: "不生效",
      tab_lab_title6: "版本ID",
      tab_lab_title7: "Android",
      tab_lab_title8: "iOS",
      tab_lab_title9: "",
      tab_lab_title10: ""
    },
    // 铭牌管理
    nameplateManagement: {
      select_lab1: "铭牌名称",
      select_lab2: "新增铭牌",
      select_lab3: "铭牌ID",
      select_lab4: "架上顺序",
      select_lab5: "用户名单",
      select_lab6: "铭牌特效",
      select_lab7: "点击上传铭牌特效",
      select_lab8: "添加用户",
      select_lab9: "用户ID",
      select_lab10: "用户昵称",
      select_lab11: "获得时间",
      select_lab12: "失效时间",
      select_lab13: "删除",
      select_lab14: "请上传铭牌特效",
      select_lab15: "铭牌新增成功",
      select_lab16: "铭牌展示图片"
    },
    // 房间标签管理
    roomLabelManagement: {
      select_lab1: "标签名称",
      select_lab2: "新增标签",
      select_lab3: "标签ID",
      select_lab4: "架上顺序",
      select_lab5: "用户名单",
      select_lab6: "标签特效",
      select_lab7: "点击上传标签特效",
      select_lab8: "添加用户",
      select_lab9: "用户ID",
      select_lab10: "用户昵称",
      select_lab11: "获得时间",
      select_lab12: "失效时间",
      select_lab13: "删除",
      select_lab14: "请上传标签特效",
      select_lab15: "标签新增成功",
      select_lab16: "标签展示图片",
      select_lab17: "点击上传标签图片",
      select_lab18: "确认删除该用户的标签？",
      select_lab19: "标签(反转)特效",
      select_lab20: "点击上传标签(反转)特效"
    },
    // 房间头像框管理
    roomHeaderManagement: {
      select_lab1: "头像框名称",
      select_lab2: "新增头像框",
      select_lab3: "头像框ID",
      select_lab4: "架上顺序",
      select_lab5: "用户名单",
      select_lab6: "头像框特效",
      select_lab7: "点击上传头像框特效",
      select_lab8: "添加用户",
      select_lab9: "用户ID",
      select_lab10: "用户昵称",
      select_lab11: "获得时间",
      select_lab12: "失效时间",
      select_lab13: "删除",
      select_lab14: "请上传头像框特效",
      select_lab15: "头像框新增成功",
      select_lab16: "头像框展示图片",
      select_lab17: "点击上传头像框图片",
      select_lab18: "确认删除该用户的房间头像框？"
    },
    // 皮肤管理
    skinManagement: {
      select_lab1: "个人资料弹窗皮肤名称",
      select_lab2: "新增个人资料弹窗皮肤",
      select_lab3: "个人资料弹窗皮肤ID",
      select_lab4: "架上顺序",
      select_lab5: "用户名单",
      select_lab6: "皮肤特效",
      select_lab7: "点击上传皮肤特效",
      select_lab8: "添加用户",
      select_lab9: "用户ID",
      select_lab10: "用户昵称",
      select_lab11: "获得时间",
      select_lab12: "失效时间",
      select_lab13: "删除",
      select_lab14: "请上传皮肤特效",
      select_lab15: "新增成功",
      select_lab16: "皮肤展示图片",
      select_lab17: "点击上传皮肤图片",
      select_lab18: "确认删除该用户的皮肤？",
      select_lab19: "皮肤(反转)特效",
      select_lab20: "点击上传皮肤(反转)特效",

      select_lac1: "进房间尾灯皮肤名称",
      select_lac2: "新增进房间尾灯皮肤",
      select_lac3: "进房间尾灯皮肤ID",

      select_lad1: "麦位光波皮肤名称",
      select_lad2: "新增麦位光波皮肤",
      select_lad3: "麦位光波皮肤ID",

      select_lae1: "房间聊天气泡皮肤名称",
      select_lae2: "新增房间聊天气泡皮肤",
      select_lae3: "房间聊天气泡皮肤ID"
    },
    materialDollManagement: {
      select_lab1: "挂饰名称",
      select_lab2: "新增挂饰",
      select_lab3: "挂饰ID",
      select_lab4: "架上顺序",
      select_lab5: "用户名单",
      select_lab6: "挂饰特效",
      select_lab7: "点击上传挂饰特效",
      select_lab8: "添加用户",
      select_lab9: "用户ID",
      select_lab10: "用户昵称",
      select_lab11: "获得时间",
      select_lab12: "失效时间",
      select_lab13: "删除",
      select_lab14: "请上传挂饰特效",
      select_lab15: "挂饰新增成功",
      select_lab16: "挂饰展示图片",
      select_lab17: "点击上传挂饰图片",
      select_lab18: "确认删除该用户的挂饰？"
    },
    ornamentManagement: {
      select_lab1: "装饰名称",
      select_lab2: "新增ID装饰",
      select_lab3: "装饰ID",
      select_lab4: "架上顺序",
      select_lab5: "用户名单",
      select_lab6: "装饰特效",
      select_lab7: "点击上传装饰特效",
      select_lab8: "添加用户",
      select_lab9: "用户ID",
      select_lab10: "用户昵称",
      select_lab11: "获得时间",
      select_lab12: "失效时间",
      select_lab13: "删除",
      select_lab14: "请上传装饰特效",
      select_lab15: "装饰新增成功",
      select_lab16: "装饰展示图片",
      select_lab17: "ID类型"
    },
    actBlacklist: {
      list01: "新增黑名单",
      list02: "用户ID",
      list03: "用户昵称",
      list04: "所属国家",
      list05: "删除",
      list06: "是否把用户",
      list07: "移出黑名单?",
      list08: "成功移出",
      list09: "添加"
    },
    whitelist: {
      list01: "新增黑白名单",
      list02: "用户ID",
      list03: "IP",
      list04: "Imei",
      list05: "账号类型",
      list06: "操作类型",
      list07: "加白",
      list08: "拉黑",

      table1: "头像",
      table2: "昵称",
      table3: "ip",
      table4: "拉黑ip",
      table5: "设备号",
      table6: "拉黑设备号	",
      table7: "区域国家",
      table8: "备注",
      table9: "财富等级",
      table10: "操作时间"
    }
  },
  components: {
    banModal: {
      chooseTime: "选择封禁时间",
      chooseReason: "选择原因",
      content: "举报内容：",
      enterContent: "可输入举报内容",
      enterUrl: "可输入图片或视频链接",
      imgVideoUrl: "图片或视频链接：",
      banUser: "确认封禁该用户？",
      banWay: "封禁方式",
      banUserText: "封禁用户",
      banDev: "封禁设备"
    },
    loginForm: {
      enterUserName: "请输入用户名",
      enterPassword: "请输入密码",
      login: "登录",
      accountNotNone: "账号不能为空",
      passwordNotNone: "密码不能为空"
    },
    fullScreen: {
      exitScreen: "退出全屏",
      fullScreen: "全屏"
    },
    headerBar: {
      title: "hilo后台管理系统"
    },
    tagsNav: {
      closeAll: "关闭所有",
      closeOther: "关闭其他"
    },
    user: {
      signOut: "退出登录"
    },
    publicCheckPassword: {
      checkPassword: "输入操作密码，并确认",
      checkSuccess: "校验成功"
    },
    tableBox: {
      noneData: "暂无数据"
    },
    tableSearch: {
      search: "查询条件"
    }
  },
  js: {
    request: {
      unLogin: "未登录",
      timeOut: "请求超时",
      unknownMis: "未知错误",
      linkError: "网络连接失败",
      requestFail: "请求失败",

      serverError: "服务器内部错误",
      missParams: "缺少参数",
      unToken: "未提交Token",
      tokenExpired: "Token过期",
      addError: "添加失败，管理员已存在",
      noFoundAdmin: "找不到此管理员",
      loginError: "登录失败，账号或密码错误"
    }
  }
};



// WEBPACK FOOTER //
// ./src/language/zh-cn.js